/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AuthRouteRouteImport } from "./routes/auth/route";
import { Route as PublicRouteRouteImport } from "./routes/_public/route";
import { Route as PrivateRouteRouteImport } from "./routes/_private/route";
import { Route as PrivateIndexRouteImport } from "./routes/_private/index";
import { Route as AuthMfaChallengeRouteImport } from "./routes/auth/mfa-challenge";
import { Route as AuthLoginRouteImport } from "./routes/auth/login";
import { Route as AuthForgotPasswordRouteImport } from "./routes/auth/forgot-password";
import { Route as AuthActionRouteImport } from "./routes/auth/action";
import { Route as PublicTermsOfUseRouteImport } from "./routes/_public/terms-of-use";
import { Route as PublicPrivacyPolicyRouteImport } from "./routes/_public/privacy-policy";
import { Route as PublicMcpLoginRouteImport } from "./routes/_public/mcp-login";
import { Route as PrivateReleaseNotesRouteImport } from "./routes/_private/release-notes";
import { Route as PrivateProductRouteRouteImport } from "./routes/_private/product/route";
import { Route as PrivateCatalogProductRouteRouteImport } from "./routes/_private/catalog-product/route";
import { Route as PrivateWarehouse360RouteRouteImport } from "./routes/_private/_warehouse-360/route";
import { Route as PrivateStock360RouteRouteImport } from "./routes/_private/_stock-360/route";
import { Route as PrivateSales360RouteRouteImport } from "./routes/_private/_sales-360/route";
import { Route as PrivatePractice360RouteRouteImport } from "./routes/_private/_practice-360/route";
import { Route as PrivatePharmacy360RouteRouteImport } from "./routes/_private/_pharmacy-360/route";
import { Route as PrivatePatientPharmcy360RouteRouteImport } from "./routes/_private/_patient-pharmcy-360/route";
import { Route as PrivatePatient360RouteRouteImport } from "./routes/_private/_patient-360/route";
import { Route as PrivateInventory360RouteRouteImport } from "./routes/_private/_inventory-360/route";
import { Route as PrivateFulfillment360RouteRouteImport } from "./routes/_private/_fulfillment-360/route";
import { Route as PrivateBulkInvoiceRouteRouteImport } from "./routes/_private/_bulk-invoice/route";
import { Route as PrivateAdminRouteRouteImport } from "./routes/_private/_admin/route";
import { Route as PrivateProfileIndexRouteImport } from "./routes/_private/profile/index";
import { Route as PublicPatientPaymentLinkPatientPaymentLinkIdRouteImport } from "./routes/_public/patient-payment-link/$patientPaymentLinkId";
import { Route as PublicInstructionsPatientCampaignIdRouteImport } from "./routes/_public/instructions/$patientCampaignId";
import { Route as PrivateTaskLookupRouteImport } from "./routes/_private/task/lookup";
import { Route as PrivateProductBrandsRouteImport } from "./routes/_private/product/brands";
import { Route as PrivateProductBasesRouteImport } from "./routes/_private/product/bases";
import { Route as PrivateCatalogProductLookupRouteImport } from "./routes/_private/catalog-product/lookup";
import { Route as PrivateCatalogProductCreateRouteImport } from "./routes/_private/catalog-product/create";
import { Route as PrivateWarehouse360PurchaseOrdersRouteImport } from "./routes/_private/_warehouse-360/purchase-orders";
import { Route as PrivatePatient360TextingRouteImport } from "./routes/_private/_patient-360/texting";
import { Route as PrivatePatient360DispensingOverviewRouteImport } from "./routes/_private/_patient-360/dispensing-overview";
import { Route as PrivatePatient360CallingRouteImport } from "./routes/_private/_patient-360/calling";
import { Route as PrivateAdminJobsRouteImport } from "./routes/_private/_admin/jobs";
import { Route as PrivateWarehouse360AnalyticsRouteRouteImport } from "./routes/_private/_warehouse-360/_analytics/route";
import { Route as PrivateAdminUserRouteRouteImport } from "./routes/_private/_admin/user/route";
import { Route as PrivateProductTreatmentsIndexRouteImport } from "./routes/_private/product/treatments/index";
import { Route as PrivateEntityEntityIdIndexRouteImport } from "./routes/_private/entity/$entityId/index";
import { Route as PrivateCatalogProductCatalogProductIdIndexRouteImport } from "./routes/_private/catalog-product/$catalogProductId/index";
import { Route as PrivatePharmacy360Pharmacy360AnalyticsIndexRouteImport } from "./routes/_private/_pharmacy-360/pharmacy360-analytics/index";
import { Route as PrivatePatient360Patient360AnalyticsIndexRouteImport } from "./routes/_private/_patient-360/patient360-analytics/index";
import { Route as PrivateFulfillment360Fulfillment360AnalyticsIndexRouteImport } from "./routes/_private/_fulfillment-360/fulfillment360-analytics/index";
import { Route as PrivateAdminBestRxIndexRouteImport } from "./routes/_private/_admin/best-rx/index";
import { Route as PrivateAdminAiChatIndexRouteImport } from "./routes/_private/_admin/ai-chat/index";
import { Route as PrivateCatalogProductCatalogProductIdEditRouteImport } from "./routes/_private/catalog-product/$catalogProductId/edit";
import { Route as PrivateWarehouse360WarehouseLookupRouteImport } from "./routes/_private/_warehouse-360/warehouse/lookup";
import { Route as PrivateWarehouse360WarehouseCreateRouteImport } from "./routes/_private/_warehouse-360/warehouse/create";
import { Route as PrivateWarehouse360WarehouseVendorCreateRouteImport } from "./routes/_private/_warehouse-360/warehouse-vendor/create";
import { Route as PrivateWarehouse360VendorLookupRouteImport } from "./routes/_private/_warehouse-360/vendor/lookup";
import { Route as PrivateWarehouse360VendorCreateRouteImport } from "./routes/_private/_warehouse-360/vendor/create";
import { Route as PrivateWarehouse360BatchLookupRouteImport } from "./routes/_private/_warehouse-360/batch/lookup";
import { Route as PrivateWarehouse360BatchCreateRouteImport } from "./routes/_private/_warehouse-360/batch/create";
import { Route as PrivateStock360StockOrderLookupRouteImport } from "./routes/_private/_stock-360/stock-order/lookup";
import { Route as PrivateStock360StockOrderCreateRouteImport } from "./routes/_private/_stock-360/stock-order/create";
import { Route as PrivateStock360OwnedStockLookupRouteImport } from "./routes/_private/_stock-360/owned-stock/lookup";
import { Route as PrivateSales360CommissionsLookupRouteImport } from "./routes/_private/_sales-360/commissions/lookup";
import { Route as PrivatePractice360BulkReorderLookupRouteImport } from "./routes/_private/_practice-360/bulk-reorder/lookup";
import { Route as PrivatePractice360BulkProductLookupRouteImport } from "./routes/_private/_practice-360/bulk-product/lookup";
import { Route as PrivatePractice360BulkProductCreateRouteImport } from "./routes/_private/_practice-360/bulk-product/create";
import { Route as PrivatePractice360BulkOrderLookupRouteImport } from "./routes/_private/_practice-360/bulk-order/lookup";
import { Route as PrivatePractice360BulkOrderCreateRouteImport } from "./routes/_private/_practice-360/bulk-order/create";
import { Route as PrivatePractice360BulkBundleLookupRouteImport } from "./routes/_private/_practice-360/bulk-bundle/lookup";
import { Route as PrivatePractice360BulkBundleCreateRouteImport } from "./routes/_private/_practice-360/bulk-bundle/create";
import { Route as PrivatePharmacy360SuborderLookupRouteImport } from "./routes/_private/_pharmacy-360/suborder/lookup";
import { Route as PrivatePatientPharmcy360ProductLookupRouteImport } from "./routes/_private/_patient-pharmcy-360/product/lookup";
import { Route as PrivatePatientPharmcy360ProductCreateRouteImport } from "./routes/_private/_patient-pharmcy-360/product/create";
import { Route as PrivatePatient360PatientLookupRouteImport } from "./routes/_private/_patient-360/patient/lookup";
import { Route as PrivatePatient360PatientCreateRouteImport } from "./routes/_private/_patient-360/patient/create";
import { Route as PrivatePatient360OrderLookupRouteImport } from "./routes/_private/_patient-360/order/lookup";
import { Route as PrivatePatient360OrderCreateRouteImport } from "./routes/_private/_patient-360/order/create";
import { Route as PrivatePatient360BundleLookupRouteImport } from "./routes/_private/_patient-360/bundle/lookup";
import { Route as PrivatePatient360BundleCreateRouteImport } from "./routes/_private/_patient-360/bundle/create";
import { Route as PrivateInventory360RecallCreateRouteImport } from "./routes/_private/_inventory-360/recall/create";
import { Route as PrivateInventory360InventoryCreateRouteImport } from "./routes/_private/_inventory-360/inventory/create";
import { Route as PrivateInventory360InventoryBatchLogLookupRouteImport } from "./routes/_private/_inventory-360/inventory-batch-log/lookup";
import { Route as PrivateBulkInvoiceBulkInvoiceLookupRouteImport } from "./routes/_private/_bulk-invoice/bulk-invoice/lookup";
import { Route as PrivateAdminUserLookupRouteImport } from "./routes/_private/_admin/user/lookup";
import { Route as PrivateAdminUserCreateRouteImport } from "./routes/_private/_admin/user/create";
import { Route as PrivateAdminPayorLookupRouteImport } from "./routes/_private/_admin/payor/lookup";
import { Route as PrivateAdminPayorCreateRouteImport } from "./routes/_private/_admin/payor/create";
import { Route as PrivateAdminEntityLookupRouteImport } from "./routes/_private/_admin/entity/lookup";
import { Route as PrivateAdminEntityCreateRouteImport } from "./routes/_private/_admin/entity/create";
import { Route as PrivateCatalogProductCatalogProductIdComponentsIndexRouteImport } from "./routes/_private/catalog-product/$catalogProductId/components/index";
import { Route as PrivateWarehouse360WarehouseWarehouseIdIndexRouteImport } from "./routes/_private/_warehouse-360/warehouse/$warehouseId/index";
import { Route as PrivateWarehouse360VendorVendorIdIndexRouteImport } from "./routes/_private/_warehouse-360/vendor/$vendorId/index";
import { Route as PrivateWarehouse360BatchBatchIdIndexRouteImport } from "./routes/_private/_warehouse-360/batch/$batchId/index";
import { Route as PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRouteImport } from "./routes/_private/_warehouse-360/_analytics/warehouse360-analytics/index";
import { Route as PrivateStock360StockOrderStockOrderIdIndexRouteImport } from "./routes/_private/_stock-360/stock-order/$stockOrderId/index";
import { Route as PrivateStock360OwnedStockCatalogProductIdIndexRouteImport } from "./routes/_private/_stock-360/owned-stock/$catalogProductId/index";
import { Route as PrivatePractice360BulkProductBulkProductIdIndexRouteImport } from "./routes/_private/_practice-360/bulk-product/$bulkProductId/index";
import { Route as PrivatePractice360BulkOrderBulkOrderIdIndexRouteImport } from "./routes/_private/_practice-360/bulk-order/$bulkOrderId/index";
import { Route as PrivatePractice360BulkBundleBulkBundleIdIndexRouteImport } from "./routes/_private/_practice-360/bulk-bundle/$bulkBundleId/index";
import { Route as PrivatePharmacy360SuborderSuborderIdIndexRouteImport } from "./routes/_private/_pharmacy-360/suborder/$suborderId/index";
import { Route as PrivatePatientPharmcy360ProductProductIdIndexRouteImport } from "./routes/_private/_patient-pharmcy-360/product/$productId/index";
import { Route as PrivatePatient360PatientPatientIdIndexRouteImport } from "./routes/_private/_patient-360/patient/$patientId/index";
import { Route as PrivatePatient360OrderOrderIdIndexRouteImport } from "./routes/_private/_patient-360/order/$orderId/index";
import { Route as PrivatePatient360BundleBundleIdIndexRouteImport } from "./routes/_private/_patient-360/bundle/$bundleId/index";
import { Route as PrivateInventory360RecallLookupIndexRouteImport } from "./routes/_private/_inventory-360/recall/lookup/index";
import { Route as PrivateInventory360RecallRecallEventIdIndexRouteImport } from "./routes/_private/_inventory-360/recall/$recallEventId/index";
import { Route as PrivateInventory360InventoryLookupIndexRouteImport } from "./routes/_private/_inventory-360/inventory/lookup/index";
import { Route as PrivateInventory360InventoryInventoryIdIndexRouteImport } from "./routes/_private/_inventory-360/inventory/$inventoryId/index";
import { Route as PrivateInventory360InventoryVendorLookupIndexRouteImport } from "./routes/_private/_inventory-360/inventory-vendor/lookup/index";
import { Route as PrivateInventory360InventoryLotLookupIndexRouteImport } from "./routes/_private/_inventory-360/inventory-lot/lookup/index";
import { Route as PrivateFulfillment360BulkSuborderLookupIndexRouteImport } from "./routes/_private/_fulfillment-360/bulk-suborder/lookup/index";
import { Route as PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRouteImport } from "./routes/_private/_fulfillment-360/bulk-suborder/$bulkSuborderId/index";
import { Route as PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRouteImport } from "./routes/_private/_bulk-invoice/bulk-invoice/$bulkInvoiceId/index";
import { Route as PrivateAdminUserUserIdIndexRouteImport } from "./routes/_private/_admin/user/$userId/index";
import { Route as PrivateAdminPayorPayorIdIndexRouteImport } from "./routes/_private/_admin/payor/$payorId/index";
import { Route as PrivateWarehouse360WarehouseWarehouseIdEditRouteImport } from "./routes/_private/_warehouse-360/warehouse/$warehouseId/edit";
import { Route as PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRouteImport } from "./routes/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit";
import { Route as PrivateWarehouse360VendorVendorIdEditRouteImport } from "./routes/_private/_warehouse-360/vendor/$vendorId/edit";
import { Route as PrivateWarehouse360BatchBatchIdEditRouteImport } from "./routes/_private/_warehouse-360/batch/$batchId/edit";
import { Route as PrivateStock360StockOrderStockOrderIdEditRouteImport } from "./routes/_private/_stock-360/stock-order/$stockOrderId/edit";
import { Route as PrivatePractice360BulkProductBulkProductIdEditRouteImport } from "./routes/_private/_practice-360/bulk-product/$bulkProductId/edit";
import { Route as PrivatePractice360BulkOrderBulkOrderIdEditRouteImport } from "./routes/_private/_practice-360/bulk-order/$bulkOrderId/edit";
import { Route as PrivatePractice360BulkBundleBulkBundleIdEditRouteImport } from "./routes/_private/_practice-360/bulk-bundle/$bulkBundleId/edit";
import { Route as PrivatePatientPharmcy360ProductProductIdEditRouteImport } from "./routes/_private/_patient-pharmcy-360/product/$productId/edit";
import { Route as PrivatePatient360OrderOrderIdEditRouteImport } from "./routes/_private/_patient-360/order/$orderId/edit";
import { Route as PrivatePatient360BundleBundleIdEditRouteImport } from "./routes/_private/_patient-360/bundle/$bundleId/edit";
import { Route as PrivateInventory360InventoryInventoryIdEditRouteImport } from "./routes/_private/_inventory-360/inventory/$inventoryId/edit";
import { Route as PrivateAdminUserUserIdEditRouteImport } from "./routes/_private/_admin/user/$userId/edit";
import { Route as PrivateAdminPayorPayorIdEditRouteImport } from "./routes/_private/_admin/payor/$payorId/edit";
import { Route as PrivateAdminEntityEntityIdEditRouteImport } from "./routes/_private/_admin/entity/$entityId/edit";
import { Route as PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRouteImport } from "./routes/_private/_warehouse-360/_analytics/warehouse360-analytics/monthly-historic/index";
import { Route as PrivateStock360StockOrderStockOrderIdContentsIndexRouteImport } from "./routes/_private/_stock-360/stock-order/$stockOrderId/contents/index";
import { Route as PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRouteImport } from "./routes/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/index";
import { Route as PrivatePractice360BulkOrderBulkOrderIdContentsIndexRouteImport } from "./routes/_private/_practice-360/bulk-order/$bulkOrderId/contents/index";
import { Route as PrivatePractice360BulkBundleBulkBundleIdProductsIndexRouteImport } from "./routes/_private/_practice-360/bulk-bundle/$bulkBundleId/products/index";
import { Route as PrivatePatient360OrderOrderIdContentsIndexRouteImport } from "./routes/_private/_patient-360/order/$orderId/contents/index";
import { Route as PrivatePatient360BundleBundleIdProductsIndexRouteImport } from "./routes/_private/_patient-360/bundle/$bundleId/products/index";
import { Route as PrivateAdminUserUserIdPermissionsIndexRouteImport } from "./routes/_private/_admin/user/$userId/permissions/index";
import { Route as PrivateAdminUserUserIdEntitiesIndexRouteImport } from "./routes/_private/_admin/user/$userId/entities/index";
import { Route as PrivateAdminUserUserIdCommissionsIndexRouteImport } from "./routes/_private/_admin/user/$userId/commissions/index";
import { Route as PrivateAdminEntityEntityIdVisibilityIndexRouteImport } from "./routes/_private/_admin/entity/$entityId/visibility/index";
import { Route as PrivateAdminEntityEntityIdServicesIndexRouteImport } from "./routes/_private/_admin/entity/$entityId/services/index";
import { Route as PrivatePatient360PatientPatientIdCreatePaymentRouteImport } from "./routes/_private/_patient-360/patient/$patientId/create/payment";
import { Route as PrivatePatient360PatientPatientIdCreatePatientPayorRouteImport } from "./routes/_private/_patient-360/patient/$patientId/create/patient-payor";
import { Route as PrivatePatient360PatientPatientIdCreateAddressRouteImport } from "./routes/_private/_patient-360/patient/$patientId/create/address";
import { Route as PrivateInventory360InventoryInventoryIdLotUnassignedRouteImport } from "./routes/_private/_inventory-360/inventory/$inventoryId/lot/unassigned";
import { Route as PrivateInventory360InventoryInventoryIdLotLotNumberRouteImport } from "./routes/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber";

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: "/auth",
  path: "/auth",
  getParentRoute: () => rootRouteImport,
} as any);
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: "/_public",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: "/_private",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivateIndexRoute = PrivateIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const AuthMfaChallengeRoute = AuthMfaChallengeRouteImport.update({
  id: "/mfa-challenge",
  path: "/mfa-challenge",
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthActionRoute = AuthActionRouteImport.update({
  id: "/action",
  path: "/action",
  getParentRoute: () => AuthRouteRoute,
} as any);
const PublicTermsOfUseRoute = PublicTermsOfUseRouteImport.update({
  id: "/terms-of-use",
  path: "/terms-of-use",
  getParentRoute: () => PublicRouteRoute,
} as any);
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
  id: "/privacy-policy",
  path: "/privacy-policy",
  getParentRoute: () => PublicRouteRoute,
} as any);
const PublicMcpLoginRoute = PublicMcpLoginRouteImport.update({
  id: "/mcp-login",
  path: "/mcp-login",
  getParentRoute: () => PublicRouteRoute,
} as any);
const PrivateReleaseNotesRoute = PrivateReleaseNotesRouteImport.update({
  id: "/release-notes",
  path: "/release-notes",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateProductRouteRoute = PrivateProductRouteRouteImport.update({
  id: "/product",
  path: "/product",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateCatalogProductRouteRoute =
  PrivateCatalogProductRouteRouteImport.update({
    id: "/catalog-product",
    path: "/catalog-product",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateWarehouse360RouteRoute =
  PrivateWarehouse360RouteRouteImport.update({
    id: "/_warehouse-360",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateStock360RouteRoute = PrivateStock360RouteRouteImport.update({
  id: "/_stock-360",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateSales360RouteRoute = PrivateSales360RouteRouteImport.update({
  id: "/_sales-360",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivatePractice360RouteRoute = PrivatePractice360RouteRouteImport.update({
  id: "/_practice-360",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivatePharmacy360RouteRoute = PrivatePharmacy360RouteRouteImport.update({
  id: "/_pharmacy-360",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivatePatientPharmcy360RouteRoute =
  PrivatePatientPharmcy360RouteRouteImport.update({
    id: "/_patient-pharmcy-360",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivatePatient360RouteRoute = PrivatePatient360RouteRouteImport.update({
  id: "/_patient-360",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateInventory360RouteRoute =
  PrivateInventory360RouteRouteImport.update({
    id: "/_inventory-360",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateFulfillment360RouteRoute =
  PrivateFulfillment360RouteRouteImport.update({
    id: "/_fulfillment-360",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateBulkInvoiceRouteRoute = PrivateBulkInvoiceRouteRouteImport.update({
  id: "/_bulk-invoice",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateAdminRouteRoute = PrivateAdminRouteRouteImport.update({
  id: "/_admin",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateProfileIndexRoute = PrivateProfileIndexRouteImport.update({
  id: "/profile/",
  path: "/profile/",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PublicPatientPaymentLinkPatientPaymentLinkIdRoute =
  PublicPatientPaymentLinkPatientPaymentLinkIdRouteImport.update({
    id: "/patient-payment-link/$patientPaymentLinkId",
    path: "/patient-payment-link/$patientPaymentLinkId",
    getParentRoute: () => PublicRouteRoute,
  } as any);
const PublicInstructionsPatientCampaignIdRoute =
  PublicInstructionsPatientCampaignIdRouteImport.update({
    id: "/instructions/$patientCampaignId",
    path: "/instructions/$patientCampaignId",
    getParentRoute: () => PublicRouteRoute,
  } as any);
const PrivateTaskLookupRoute = PrivateTaskLookupRouteImport.update({
  id: "/task/lookup",
  path: "/task/lookup",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateProductBrandsRoute = PrivateProductBrandsRouteImport.update({
  id: "/brands",
  path: "/brands",
  getParentRoute: () => PrivateProductRouteRoute,
} as any);
const PrivateProductBasesRoute = PrivateProductBasesRouteImport.update({
  id: "/bases",
  path: "/bases",
  getParentRoute: () => PrivateProductRouteRoute,
} as any);
const PrivateCatalogProductLookupRoute =
  PrivateCatalogProductLookupRouteImport.update({
    id: "/lookup",
    path: "/lookup",
    getParentRoute: () => PrivateCatalogProductRouteRoute,
  } as any);
const PrivateCatalogProductCreateRoute =
  PrivateCatalogProductCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => PrivateCatalogProductRouteRoute,
  } as any);
const PrivateWarehouse360PurchaseOrdersRoute =
  PrivateWarehouse360PurchaseOrdersRouteImport.update({
    id: "/purchase-orders",
    path: "/purchase-orders",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivatePatient360TextingRoute =
  PrivatePatient360TextingRouteImport.update({
    id: "/texting",
    path: "/texting",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360DispensingOverviewRoute =
  PrivatePatient360DispensingOverviewRouteImport.update({
    id: "/dispensing-overview",
    path: "/dispensing-overview",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360CallingRoute =
  PrivatePatient360CallingRouteImport.update({
    id: "/calling",
    path: "/calling",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateAdminJobsRoute = PrivateAdminJobsRouteImport.update({
  id: "/jobs",
  path: "/jobs",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateWarehouse360AnalyticsRouteRoute =
  PrivateWarehouse360AnalyticsRouteRouteImport.update({
    id: "/_analytics",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateAdminUserRouteRoute = PrivateAdminUserRouteRouteImport.update({
  id: "/user",
  path: "/user",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateProductTreatmentsIndexRoute =
  PrivateProductTreatmentsIndexRouteImport.update({
    id: "/treatments/",
    path: "/treatments/",
    getParentRoute: () => PrivateProductRouteRoute,
  } as any);
const PrivateEntityEntityIdIndexRoute =
  PrivateEntityEntityIdIndexRouteImport.update({
    id: "/entity/$entityId/",
    path: "/entity/$entityId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateCatalogProductCatalogProductIdIndexRoute =
  PrivateCatalogProductCatalogProductIdIndexRouteImport.update({
    id: "/$catalogProductId/",
    path: "/$catalogProductId/",
    getParentRoute: () => PrivateCatalogProductRouteRoute,
  } as any);
const PrivatePharmacy360Pharmacy360AnalyticsIndexRoute =
  PrivatePharmacy360Pharmacy360AnalyticsIndexRouteImport.update({
    id: "/pharmacy360-analytics/",
    path: "/pharmacy360-analytics/",
    getParentRoute: () => PrivatePharmacy360RouteRoute,
  } as any);
const PrivatePatient360Patient360AnalyticsIndexRoute =
  PrivatePatient360Patient360AnalyticsIndexRouteImport.update({
    id: "/patient360-analytics/",
    path: "/patient360-analytics/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateFulfillment360Fulfillment360AnalyticsIndexRoute =
  PrivateFulfillment360Fulfillment360AnalyticsIndexRouteImport.update({
    id: "/fulfillment360-analytics/",
    path: "/fulfillment360-analytics/",
    getParentRoute: () => PrivateFulfillment360RouteRoute,
  } as any);
const PrivateAdminBestRxIndexRoute = PrivateAdminBestRxIndexRouteImport.update({
  id: "/best-rx/",
  path: "/best-rx/",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateAdminAiChatIndexRoute = PrivateAdminAiChatIndexRouteImport.update({
  id: "/ai-chat/",
  path: "/ai-chat/",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateCatalogProductCatalogProductIdEditRoute =
  PrivateCatalogProductCatalogProductIdEditRouteImport.update({
    id: "/$catalogProductId/edit",
    path: "/$catalogProductId/edit",
    getParentRoute: () => PrivateCatalogProductRouteRoute,
  } as any);
const PrivateWarehouse360WarehouseLookupRoute =
  PrivateWarehouse360WarehouseLookupRouteImport.update({
    id: "/warehouse/lookup",
    path: "/warehouse/lookup",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360WarehouseCreateRoute =
  PrivateWarehouse360WarehouseCreateRouteImport.update({
    id: "/warehouse/create",
    path: "/warehouse/create",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360WarehouseVendorCreateRoute =
  PrivateWarehouse360WarehouseVendorCreateRouteImport.update({
    id: "/warehouse-vendor/create",
    path: "/warehouse-vendor/create",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360VendorLookupRoute =
  PrivateWarehouse360VendorLookupRouteImport.update({
    id: "/vendor/lookup",
    path: "/vendor/lookup",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360VendorCreateRoute =
  PrivateWarehouse360VendorCreateRouteImport.update({
    id: "/vendor/create",
    path: "/vendor/create",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360BatchLookupRoute =
  PrivateWarehouse360BatchLookupRouteImport.update({
    id: "/batch/lookup",
    path: "/batch/lookup",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360BatchCreateRoute =
  PrivateWarehouse360BatchCreateRouteImport.update({
    id: "/batch/create",
    path: "/batch/create",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateStock360StockOrderLookupRoute =
  PrivateStock360StockOrderLookupRouteImport.update({
    id: "/stock-order/lookup",
    path: "/stock-order/lookup",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivateStock360StockOrderCreateRoute =
  PrivateStock360StockOrderCreateRouteImport.update({
    id: "/stock-order/create",
    path: "/stock-order/create",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivateStock360OwnedStockLookupRoute =
  PrivateStock360OwnedStockLookupRouteImport.update({
    id: "/owned-stock/lookup",
    path: "/owned-stock/lookup",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivateSales360CommissionsLookupRoute =
  PrivateSales360CommissionsLookupRouteImport.update({
    id: "/commissions/lookup",
    path: "/commissions/lookup",
    getParentRoute: () => PrivateSales360RouteRoute,
  } as any);
const PrivatePractice360BulkReorderLookupRoute =
  PrivatePractice360BulkReorderLookupRouteImport.update({
    id: "/bulk-reorder/lookup",
    path: "/bulk-reorder/lookup",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkProductLookupRoute =
  PrivatePractice360BulkProductLookupRouteImport.update({
    id: "/bulk-product/lookup",
    path: "/bulk-product/lookup",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkProductCreateRoute =
  PrivatePractice360BulkProductCreateRouteImport.update({
    id: "/bulk-product/create",
    path: "/bulk-product/create",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkOrderLookupRoute =
  PrivatePractice360BulkOrderLookupRouteImport.update({
    id: "/bulk-order/lookup",
    path: "/bulk-order/lookup",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkOrderCreateRoute =
  PrivatePractice360BulkOrderCreateRouteImport.update({
    id: "/bulk-order/create",
    path: "/bulk-order/create",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkBundleLookupRoute =
  PrivatePractice360BulkBundleLookupRouteImport.update({
    id: "/bulk-bundle/lookup",
    path: "/bulk-bundle/lookup",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkBundleCreateRoute =
  PrivatePractice360BulkBundleCreateRouteImport.update({
    id: "/bulk-bundle/create",
    path: "/bulk-bundle/create",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePharmacy360SuborderLookupRoute =
  PrivatePharmacy360SuborderLookupRouteImport.update({
    id: "/suborder/lookup",
    path: "/suborder/lookup",
    getParentRoute: () => PrivatePharmacy360RouteRoute,
  } as any);
const PrivatePatientPharmcy360ProductLookupRoute =
  PrivatePatientPharmcy360ProductLookupRouteImport.update({
    id: "/product/lookup",
    path: "/product/lookup",
    getParentRoute: () => PrivatePatientPharmcy360RouteRoute,
  } as any);
const PrivatePatientPharmcy360ProductCreateRoute =
  PrivatePatientPharmcy360ProductCreateRouteImport.update({
    id: "/product/create",
    path: "/product/create",
    getParentRoute: () => PrivatePatientPharmcy360RouteRoute,
  } as any);
const PrivatePatient360PatientLookupRoute =
  PrivatePatient360PatientLookupRouteImport.update({
    id: "/patient/lookup",
    path: "/patient/lookup",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360PatientCreateRoute =
  PrivatePatient360PatientCreateRouteImport.update({
    id: "/patient/create",
    path: "/patient/create",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360OrderLookupRoute =
  PrivatePatient360OrderLookupRouteImport.update({
    id: "/order/lookup",
    path: "/order/lookup",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360OrderCreateRoute =
  PrivatePatient360OrderCreateRouteImport.update({
    id: "/order/create",
    path: "/order/create",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360BundleLookupRoute =
  PrivatePatient360BundleLookupRouteImport.update({
    id: "/bundle/lookup",
    path: "/bundle/lookup",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360BundleCreateRoute =
  PrivatePatient360BundleCreateRouteImport.update({
    id: "/bundle/create",
    path: "/bundle/create",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateInventory360RecallCreateRoute =
  PrivateInventory360RecallCreateRouteImport.update({
    id: "/recall/create",
    path: "/recall/create",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryCreateRoute =
  PrivateInventory360InventoryCreateRouteImport.update({
    id: "/inventory/create",
    path: "/inventory/create",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryBatchLogLookupRoute =
  PrivateInventory360InventoryBatchLogLookupRouteImport.update({
    id: "/inventory-batch-log/lookup",
    path: "/inventory-batch-log/lookup",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateBulkInvoiceBulkInvoiceLookupRoute =
  PrivateBulkInvoiceBulkInvoiceLookupRouteImport.update({
    id: "/bulk-invoice/lookup",
    path: "/bulk-invoice/lookup",
    getParentRoute: () => PrivateBulkInvoiceRouteRoute,
  } as any);
const PrivateAdminUserLookupRoute = PrivateAdminUserLookupRouteImport.update({
  id: "/lookup",
  path: "/lookup",
  getParentRoute: () => PrivateAdminUserRouteRoute,
} as any);
const PrivateAdminUserCreateRoute = PrivateAdminUserCreateRouteImport.update({
  id: "/create",
  path: "/create",
  getParentRoute: () => PrivateAdminUserRouteRoute,
} as any);
const PrivateAdminPayorLookupRoute = PrivateAdminPayorLookupRouteImport.update({
  id: "/payor/lookup",
  path: "/payor/lookup",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateAdminPayorCreateRoute = PrivateAdminPayorCreateRouteImport.update({
  id: "/payor/create",
  path: "/payor/create",
  getParentRoute: () => PrivateAdminRouteRoute,
} as any);
const PrivateAdminEntityLookupRoute =
  PrivateAdminEntityLookupRouteImport.update({
    id: "/entity/lookup",
    path: "/entity/lookup",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateAdminEntityCreateRoute =
  PrivateAdminEntityCreateRouteImport.update({
    id: "/entity/create",
    path: "/entity/create",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateCatalogProductCatalogProductIdComponentsIndexRoute =
  PrivateCatalogProductCatalogProductIdComponentsIndexRouteImport.update({
    id: "/$catalogProductId/components/",
    path: "/$catalogProductId/components/",
    getParentRoute: () => PrivateCatalogProductRouteRoute,
  } as any);
const PrivateWarehouse360WarehouseWarehouseIdIndexRoute =
  PrivateWarehouse360WarehouseWarehouseIdIndexRouteImport.update({
    id: "/warehouse/$warehouseId/",
    path: "/warehouse/$warehouseId/",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360VendorVendorIdIndexRoute =
  PrivateWarehouse360VendorVendorIdIndexRouteImport.update({
    id: "/vendor/$vendorId/",
    path: "/vendor/$vendorId/",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360BatchBatchIdIndexRoute =
  PrivateWarehouse360BatchBatchIdIndexRouteImport.update({
    id: "/batch/$batchId/",
    path: "/batch/$batchId/",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute =
  PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRouteImport.update({
    id: "/warehouse360-analytics/",
    path: "/warehouse360-analytics/",
    getParentRoute: () => PrivateWarehouse360AnalyticsRouteRoute,
  } as any);
const PrivateStock360StockOrderStockOrderIdIndexRoute =
  PrivateStock360StockOrderStockOrderIdIndexRouteImport.update({
    id: "/stock-order/$stockOrderId/",
    path: "/stock-order/$stockOrderId/",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivateStock360OwnedStockCatalogProductIdIndexRoute =
  PrivateStock360OwnedStockCatalogProductIdIndexRouteImport.update({
    id: "/owned-stock/$catalogProductId/",
    path: "/owned-stock/$catalogProductId/",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivatePractice360BulkProductBulkProductIdIndexRoute =
  PrivatePractice360BulkProductBulkProductIdIndexRouteImport.update({
    id: "/bulk-product/$bulkProductId/",
    path: "/bulk-product/$bulkProductId/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkOrderBulkOrderIdIndexRoute =
  PrivatePractice360BulkOrderBulkOrderIdIndexRouteImport.update({
    id: "/bulk-order/$bulkOrderId/",
    path: "/bulk-order/$bulkOrderId/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkBundleBulkBundleIdIndexRoute =
  PrivatePractice360BulkBundleBulkBundleIdIndexRouteImport.update({
    id: "/bulk-bundle/$bulkBundleId/",
    path: "/bulk-bundle/$bulkBundleId/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePharmacy360SuborderSuborderIdIndexRoute =
  PrivatePharmacy360SuborderSuborderIdIndexRouteImport.update({
    id: "/suborder/$suborderId/",
    path: "/suborder/$suborderId/",
    getParentRoute: () => PrivatePharmacy360RouteRoute,
  } as any);
const PrivatePatientPharmcy360ProductProductIdIndexRoute =
  PrivatePatientPharmcy360ProductProductIdIndexRouteImport.update({
    id: "/product/$productId/",
    path: "/product/$productId/",
    getParentRoute: () => PrivatePatientPharmcy360RouteRoute,
  } as any);
const PrivatePatient360PatientPatientIdIndexRoute =
  PrivatePatient360PatientPatientIdIndexRouteImport.update({
    id: "/patient/$patientId/",
    path: "/patient/$patientId/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360OrderOrderIdIndexRoute =
  PrivatePatient360OrderOrderIdIndexRouteImport.update({
    id: "/order/$orderId/",
    path: "/order/$orderId/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360BundleBundleIdIndexRoute =
  PrivatePatient360BundleBundleIdIndexRouteImport.update({
    id: "/bundle/$bundleId/",
    path: "/bundle/$bundleId/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateInventory360RecallLookupIndexRoute =
  PrivateInventory360RecallLookupIndexRouteImport.update({
    id: "/recall/lookup/",
    path: "/recall/lookup/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360RecallRecallEventIdIndexRoute =
  PrivateInventory360RecallRecallEventIdIndexRouteImport.update({
    id: "/recall/$recallEventId/",
    path: "/recall/$recallEventId/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryLookupIndexRoute =
  PrivateInventory360InventoryLookupIndexRouteImport.update({
    id: "/inventory/lookup/",
    path: "/inventory/lookup/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryInventoryIdIndexRoute =
  PrivateInventory360InventoryInventoryIdIndexRouteImport.update({
    id: "/inventory/$inventoryId/",
    path: "/inventory/$inventoryId/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryVendorLookupIndexRoute =
  PrivateInventory360InventoryVendorLookupIndexRouteImport.update({
    id: "/inventory-vendor/lookup/",
    path: "/inventory-vendor/lookup/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryLotLookupIndexRoute =
  PrivateInventory360InventoryLotLookupIndexRouteImport.update({
    id: "/inventory-lot/lookup/",
    path: "/inventory-lot/lookup/",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateFulfillment360BulkSuborderLookupIndexRoute =
  PrivateFulfillment360BulkSuborderLookupIndexRouteImport.update({
    id: "/bulk-suborder/lookup/",
    path: "/bulk-suborder/lookup/",
    getParentRoute: () => PrivateFulfillment360RouteRoute,
  } as any);
const PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute =
  PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRouteImport.update({
    id: "/bulk-suborder/$bulkSuborderId/",
    path: "/bulk-suborder/$bulkSuborderId/",
    getParentRoute: () => PrivateFulfillment360RouteRoute,
  } as any);
const PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute =
  PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRouteImport.update({
    id: "/bulk-invoice/$bulkInvoiceId/",
    path: "/bulk-invoice/$bulkInvoiceId/",
    getParentRoute: () => PrivateBulkInvoiceRouteRoute,
  } as any);
const PrivateAdminUserUserIdIndexRoute =
  PrivateAdminUserUserIdIndexRouteImport.update({
    id: "/$userId/",
    path: "/$userId/",
    getParentRoute: () => PrivateAdminUserRouteRoute,
  } as any);
const PrivateAdminPayorPayorIdIndexRoute =
  PrivateAdminPayorPayorIdIndexRouteImport.update({
    id: "/payor/$payorId/",
    path: "/payor/$payorId/",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateWarehouse360WarehouseWarehouseIdEditRoute =
  PrivateWarehouse360WarehouseWarehouseIdEditRouteImport.update({
    id: "/warehouse/$warehouseId/edit",
    path: "/warehouse/$warehouseId/edit",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute =
  PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRouteImport.update({
    id: "/warehouse-vendor/$warehouseVendorId/edit",
    path: "/warehouse-vendor/$warehouseVendorId/edit",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360VendorVendorIdEditRoute =
  PrivateWarehouse360VendorVendorIdEditRouteImport.update({
    id: "/vendor/$vendorId/edit",
    path: "/vendor/$vendorId/edit",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateWarehouse360BatchBatchIdEditRoute =
  PrivateWarehouse360BatchBatchIdEditRouteImport.update({
    id: "/batch/$batchId/edit",
    path: "/batch/$batchId/edit",
    getParentRoute: () => PrivateWarehouse360RouteRoute,
  } as any);
const PrivateStock360StockOrderStockOrderIdEditRoute =
  PrivateStock360StockOrderStockOrderIdEditRouteImport.update({
    id: "/stock-order/$stockOrderId/edit",
    path: "/stock-order/$stockOrderId/edit",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivatePractice360BulkProductBulkProductIdEditRoute =
  PrivatePractice360BulkProductBulkProductIdEditRouteImport.update({
    id: "/bulk-product/$bulkProductId/edit",
    path: "/bulk-product/$bulkProductId/edit",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkOrderBulkOrderIdEditRoute =
  PrivatePractice360BulkOrderBulkOrderIdEditRouteImport.update({
    id: "/bulk-order/$bulkOrderId/edit",
    path: "/bulk-order/$bulkOrderId/edit",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkBundleBulkBundleIdEditRoute =
  PrivatePractice360BulkBundleBulkBundleIdEditRouteImport.update({
    id: "/bulk-bundle/$bulkBundleId/edit",
    path: "/bulk-bundle/$bulkBundleId/edit",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePatientPharmcy360ProductProductIdEditRoute =
  PrivatePatientPharmcy360ProductProductIdEditRouteImport.update({
    id: "/product/$productId/edit",
    path: "/product/$productId/edit",
    getParentRoute: () => PrivatePatientPharmcy360RouteRoute,
  } as any);
const PrivatePatient360OrderOrderIdEditRoute =
  PrivatePatient360OrderOrderIdEditRouteImport.update({
    id: "/order/$orderId/edit",
    path: "/order/$orderId/edit",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360BundleBundleIdEditRoute =
  PrivatePatient360BundleBundleIdEditRouteImport.update({
    id: "/bundle/$bundleId/edit",
    path: "/bundle/$bundleId/edit",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateInventory360InventoryInventoryIdEditRoute =
  PrivateInventory360InventoryInventoryIdEditRouteImport.update({
    id: "/inventory/$inventoryId/edit",
    path: "/inventory/$inventoryId/edit",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateAdminUserUserIdEditRoute =
  PrivateAdminUserUserIdEditRouteImport.update({
    id: "/$userId/edit",
    path: "/$userId/edit",
    getParentRoute: () => PrivateAdminUserRouteRoute,
  } as any);
const PrivateAdminPayorPayorIdEditRoute =
  PrivateAdminPayorPayorIdEditRouteImport.update({
    id: "/payor/$payorId/edit",
    path: "/payor/$payorId/edit",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateAdminEntityEntityIdEditRoute =
  PrivateAdminEntityEntityIdEditRouteImport.update({
    id: "/entity/$entityId/edit",
    path: "/entity/$entityId/edit",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute =
  PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRouteImport.update(
    {
      id: "/warehouse360-analytics/monthly-historic/",
      path: "/warehouse360-analytics/monthly-historic/",
      getParentRoute: () => PrivateWarehouse360AnalyticsRouteRoute,
    } as any,
  );
const PrivateStock360StockOrderStockOrderIdContentsIndexRoute =
  PrivateStock360StockOrderStockOrderIdContentsIndexRouteImport.update({
    id: "/stock-order/$stockOrderId/contents/",
    path: "/stock-order/$stockOrderId/contents/",
    getParentRoute: () => PrivateStock360RouteRoute,
  } as any);
const PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute =
  PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRouteImport.update({
    id: "/bulk-reorder/$bulkOrderId/schedule/",
    path: "/bulk-reorder/$bulkOrderId/schedule/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute =
  PrivatePractice360BulkOrderBulkOrderIdContentsIndexRouteImport.update({
    id: "/bulk-order/$bulkOrderId/contents/",
    path: "/bulk-order/$bulkOrderId/contents/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute =
  PrivatePractice360BulkBundleBulkBundleIdProductsIndexRouteImport.update({
    id: "/bulk-bundle/$bulkBundleId/products/",
    path: "/bulk-bundle/$bulkBundleId/products/",
    getParentRoute: () => PrivatePractice360RouteRoute,
  } as any);
const PrivatePatient360OrderOrderIdContentsIndexRoute =
  PrivatePatient360OrderOrderIdContentsIndexRouteImport.update({
    id: "/order/$orderId/contents/",
    path: "/order/$orderId/contents/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360BundleBundleIdProductsIndexRoute =
  PrivatePatient360BundleBundleIdProductsIndexRouteImport.update({
    id: "/bundle/$bundleId/products/",
    path: "/bundle/$bundleId/products/",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateAdminUserUserIdPermissionsIndexRoute =
  PrivateAdminUserUserIdPermissionsIndexRouteImport.update({
    id: "/$userId/permissions/",
    path: "/$userId/permissions/",
    getParentRoute: () => PrivateAdminUserRouteRoute,
  } as any);
const PrivateAdminUserUserIdEntitiesIndexRoute =
  PrivateAdminUserUserIdEntitiesIndexRouteImport.update({
    id: "/$userId/entities/",
    path: "/$userId/entities/",
    getParentRoute: () => PrivateAdminUserRouteRoute,
  } as any);
const PrivateAdminUserUserIdCommissionsIndexRoute =
  PrivateAdminUserUserIdCommissionsIndexRouteImport.update({
    id: "/$userId/commissions/",
    path: "/$userId/commissions/",
    getParentRoute: () => PrivateAdminUserRouteRoute,
  } as any);
const PrivateAdminEntityEntityIdVisibilityIndexRoute =
  PrivateAdminEntityEntityIdVisibilityIndexRouteImport.update({
    id: "/entity/$entityId/visibility/",
    path: "/entity/$entityId/visibility/",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivateAdminEntityEntityIdServicesIndexRoute =
  PrivateAdminEntityEntityIdServicesIndexRouteImport.update({
    id: "/entity/$entityId/services/",
    path: "/entity/$entityId/services/",
    getParentRoute: () => PrivateAdminRouteRoute,
  } as any);
const PrivatePatient360PatientPatientIdCreatePaymentRoute =
  PrivatePatient360PatientPatientIdCreatePaymentRouteImport.update({
    id: "/patient/$patientId/create/payment",
    path: "/patient/$patientId/create/payment",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360PatientPatientIdCreatePatientPayorRoute =
  PrivatePatient360PatientPatientIdCreatePatientPayorRouteImport.update({
    id: "/patient/$patientId/create/patient-payor",
    path: "/patient/$patientId/create/patient-payor",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivatePatient360PatientPatientIdCreateAddressRoute =
  PrivatePatient360PatientPatientIdCreateAddressRouteImport.update({
    id: "/patient/$patientId/create/address",
    path: "/patient/$patientId/create/address",
    getParentRoute: () => PrivatePatient360RouteRoute,
  } as any);
const PrivateInventory360InventoryInventoryIdLotUnassignedRoute =
  PrivateInventory360InventoryInventoryIdLotUnassignedRouteImport.update({
    id: "/inventory/$inventoryId/lot/unassigned",
    path: "/inventory/$inventoryId/lot/unassigned",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);
const PrivateInventory360InventoryInventoryIdLotLotNumberRoute =
  PrivateInventory360InventoryInventoryIdLotLotNumberRouteImport.update({
    id: "/inventory/$inventoryId/lot/$lotNumber",
    path: "/inventory/$inventoryId/lot/$lotNumber",
    getParentRoute: () => PrivateInventory360RouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof PrivateIndexRoute;
  "/auth": typeof AuthRouteRouteWithChildren;
  "/catalog-product": typeof PrivateCatalogProductRouteRouteWithChildren;
  "/product": typeof PrivateProductRouteRouteWithChildren;
  "/release-notes": typeof PrivateReleaseNotesRoute;
  "/mcp-login": typeof PublicMcpLoginRoute;
  "/privacy-policy": typeof PublicPrivacyPolicyRoute;
  "/terms-of-use": typeof PublicTermsOfUseRoute;
  "/auth/action": typeof AuthActionRoute;
  "/auth/forgot-password": typeof AuthForgotPasswordRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/mfa-challenge": typeof AuthMfaChallengeRoute;
  "/user": typeof PrivateAdminUserRouteRouteWithChildren;
  "/jobs": typeof PrivateAdminJobsRoute;
  "/calling": typeof PrivatePatient360CallingRoute;
  "/dispensing-overview": typeof PrivatePatient360DispensingOverviewRoute;
  "/texting": typeof PrivatePatient360TextingRoute;
  "/purchase-orders": typeof PrivateWarehouse360PurchaseOrdersRoute;
  "/catalog-product/create": typeof PrivateCatalogProductCreateRoute;
  "/catalog-product/lookup": typeof PrivateCatalogProductLookupRoute;
  "/product/bases": typeof PrivateProductBasesRoute;
  "/product/brands": typeof PrivateProductBrandsRoute;
  "/task/lookup": typeof PrivateTaskLookupRoute;
  "/instructions/$patientCampaignId": typeof PublicInstructionsPatientCampaignIdRoute;
  "/patient-payment-link/$patientPaymentLinkId": typeof PublicPatientPaymentLinkPatientPaymentLinkIdRoute;
  "/profile/": typeof PrivateProfileIndexRoute;
  "/entity/create": typeof PrivateAdminEntityCreateRoute;
  "/entity/lookup": typeof PrivateAdminEntityLookupRoute;
  "/payor/create": typeof PrivateAdminPayorCreateRoute;
  "/payor/lookup": typeof PrivateAdminPayorLookupRoute;
  "/user/create": typeof PrivateAdminUserCreateRoute;
  "/user/lookup": typeof PrivateAdminUserLookupRoute;
  "/bulk-invoice/lookup": typeof PrivateBulkInvoiceBulkInvoiceLookupRoute;
  "/inventory-batch-log/lookup": typeof PrivateInventory360InventoryBatchLogLookupRoute;
  "/inventory/create": typeof PrivateInventory360InventoryCreateRoute;
  "/recall/create": typeof PrivateInventory360RecallCreateRoute;
  "/bundle/create": typeof PrivatePatient360BundleCreateRoute;
  "/bundle/lookup": typeof PrivatePatient360BundleLookupRoute;
  "/order/create": typeof PrivatePatient360OrderCreateRoute;
  "/order/lookup": typeof PrivatePatient360OrderLookupRoute;
  "/patient/create": typeof PrivatePatient360PatientCreateRoute;
  "/patient/lookup": typeof PrivatePatient360PatientLookupRoute;
  "/product/create": typeof PrivatePatientPharmcy360ProductCreateRoute;
  "/product/lookup": typeof PrivatePatientPharmcy360ProductLookupRoute;
  "/suborder/lookup": typeof PrivatePharmacy360SuborderLookupRoute;
  "/bulk-bundle/create": typeof PrivatePractice360BulkBundleCreateRoute;
  "/bulk-bundle/lookup": typeof PrivatePractice360BulkBundleLookupRoute;
  "/bulk-order/create": typeof PrivatePractice360BulkOrderCreateRoute;
  "/bulk-order/lookup": typeof PrivatePractice360BulkOrderLookupRoute;
  "/bulk-product/create": typeof PrivatePractice360BulkProductCreateRoute;
  "/bulk-product/lookup": typeof PrivatePractice360BulkProductLookupRoute;
  "/bulk-reorder/lookup": typeof PrivatePractice360BulkReorderLookupRoute;
  "/commissions/lookup": typeof PrivateSales360CommissionsLookupRoute;
  "/owned-stock/lookup": typeof PrivateStock360OwnedStockLookupRoute;
  "/stock-order/create": typeof PrivateStock360StockOrderCreateRoute;
  "/stock-order/lookup": typeof PrivateStock360StockOrderLookupRoute;
  "/batch/create": typeof PrivateWarehouse360BatchCreateRoute;
  "/batch/lookup": typeof PrivateWarehouse360BatchLookupRoute;
  "/vendor/create": typeof PrivateWarehouse360VendorCreateRoute;
  "/vendor/lookup": typeof PrivateWarehouse360VendorLookupRoute;
  "/warehouse-vendor/create": typeof PrivateWarehouse360WarehouseVendorCreateRoute;
  "/warehouse/create": typeof PrivateWarehouse360WarehouseCreateRoute;
  "/warehouse/lookup": typeof PrivateWarehouse360WarehouseLookupRoute;
  "/catalog-product/$catalogProductId/edit": typeof PrivateCatalogProductCatalogProductIdEditRoute;
  "/ai-chat/": typeof PrivateAdminAiChatIndexRoute;
  "/best-rx/": typeof PrivateAdminBestRxIndexRoute;
  "/fulfillment360-analytics/": typeof PrivateFulfillment360Fulfillment360AnalyticsIndexRoute;
  "/patient360-analytics/": typeof PrivatePatient360Patient360AnalyticsIndexRoute;
  "/pharmacy360-analytics/": typeof PrivatePharmacy360Pharmacy360AnalyticsIndexRoute;
  "/catalog-product/$catalogProductId/": typeof PrivateCatalogProductCatalogProductIdIndexRoute;
  "/entity/$entityId/": typeof PrivateEntityEntityIdIndexRoute;
  "/product/treatments/": typeof PrivateProductTreatmentsIndexRoute;
  "/entity/$entityId/edit": typeof PrivateAdminEntityEntityIdEditRoute;
  "/payor/$payorId/edit": typeof PrivateAdminPayorPayorIdEditRoute;
  "/user/$userId/edit": typeof PrivateAdminUserUserIdEditRoute;
  "/inventory/$inventoryId/edit": typeof PrivateInventory360InventoryInventoryIdEditRoute;
  "/bundle/$bundleId/edit": typeof PrivatePatient360BundleBundleIdEditRoute;
  "/order/$orderId/edit": typeof PrivatePatient360OrderOrderIdEditRoute;
  "/product/$productId/edit": typeof PrivatePatientPharmcy360ProductProductIdEditRoute;
  "/bulk-bundle/$bulkBundleId/edit": typeof PrivatePractice360BulkBundleBulkBundleIdEditRoute;
  "/bulk-order/$bulkOrderId/edit": typeof PrivatePractice360BulkOrderBulkOrderIdEditRoute;
  "/bulk-product/$bulkProductId/edit": typeof PrivatePractice360BulkProductBulkProductIdEditRoute;
  "/stock-order/$stockOrderId/edit": typeof PrivateStock360StockOrderStockOrderIdEditRoute;
  "/batch/$batchId/edit": typeof PrivateWarehouse360BatchBatchIdEditRoute;
  "/vendor/$vendorId/edit": typeof PrivateWarehouse360VendorVendorIdEditRoute;
  "/warehouse-vendor/$warehouseVendorId/edit": typeof PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute;
  "/warehouse/$warehouseId/edit": typeof PrivateWarehouse360WarehouseWarehouseIdEditRoute;
  "/payor/$payorId/": typeof PrivateAdminPayorPayorIdIndexRoute;
  "/user/$userId/": typeof PrivateAdminUserUserIdIndexRoute;
  "/bulk-invoice/$bulkInvoiceId/": typeof PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute;
  "/bulk-suborder/$bulkSuborderId/": typeof PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute;
  "/bulk-suborder/lookup/": typeof PrivateFulfillment360BulkSuborderLookupIndexRoute;
  "/inventory-lot/lookup/": typeof PrivateInventory360InventoryLotLookupIndexRoute;
  "/inventory-vendor/lookup/": typeof PrivateInventory360InventoryVendorLookupIndexRoute;
  "/inventory/$inventoryId/": typeof PrivateInventory360InventoryInventoryIdIndexRoute;
  "/inventory/lookup/": typeof PrivateInventory360InventoryLookupIndexRoute;
  "/recall/$recallEventId/": typeof PrivateInventory360RecallRecallEventIdIndexRoute;
  "/recall/lookup/": typeof PrivateInventory360RecallLookupIndexRoute;
  "/bundle/$bundleId/": typeof PrivatePatient360BundleBundleIdIndexRoute;
  "/order/$orderId/": typeof PrivatePatient360OrderOrderIdIndexRoute;
  "/patient/$patientId/": typeof PrivatePatient360PatientPatientIdIndexRoute;
  "/product/$productId/": typeof PrivatePatientPharmcy360ProductProductIdIndexRoute;
  "/suborder/$suborderId/": typeof PrivatePharmacy360SuborderSuborderIdIndexRoute;
  "/bulk-bundle/$bulkBundleId/": typeof PrivatePractice360BulkBundleBulkBundleIdIndexRoute;
  "/bulk-order/$bulkOrderId/": typeof PrivatePractice360BulkOrderBulkOrderIdIndexRoute;
  "/bulk-product/$bulkProductId/": typeof PrivatePractice360BulkProductBulkProductIdIndexRoute;
  "/owned-stock/$catalogProductId/": typeof PrivateStock360OwnedStockCatalogProductIdIndexRoute;
  "/stock-order/$stockOrderId/": typeof PrivateStock360StockOrderStockOrderIdIndexRoute;
  "/warehouse360-analytics/": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute;
  "/batch/$batchId/": typeof PrivateWarehouse360BatchBatchIdIndexRoute;
  "/vendor/$vendorId/": typeof PrivateWarehouse360VendorVendorIdIndexRoute;
  "/warehouse/$warehouseId/": typeof PrivateWarehouse360WarehouseWarehouseIdIndexRoute;
  "/catalog-product/$catalogProductId/components/": typeof PrivateCatalogProductCatalogProductIdComponentsIndexRoute;
  "/inventory/$inventoryId/lot/$lotNumber": typeof PrivateInventory360InventoryInventoryIdLotLotNumberRoute;
  "/inventory/$inventoryId/lot/unassigned": typeof PrivateInventory360InventoryInventoryIdLotUnassignedRoute;
  "/patient/$patientId/create/address": typeof PrivatePatient360PatientPatientIdCreateAddressRoute;
  "/patient/$patientId/create/patient-payor": typeof PrivatePatient360PatientPatientIdCreatePatientPayorRoute;
  "/patient/$patientId/create/payment": typeof PrivatePatient360PatientPatientIdCreatePaymentRoute;
  "/entity/$entityId/services/": typeof PrivateAdminEntityEntityIdServicesIndexRoute;
  "/entity/$entityId/visibility/": typeof PrivateAdminEntityEntityIdVisibilityIndexRoute;
  "/user/$userId/commissions/": typeof PrivateAdminUserUserIdCommissionsIndexRoute;
  "/user/$userId/entities/": typeof PrivateAdminUserUserIdEntitiesIndexRoute;
  "/user/$userId/permissions/": typeof PrivateAdminUserUserIdPermissionsIndexRoute;
  "/bundle/$bundleId/products/": typeof PrivatePatient360BundleBundleIdProductsIndexRoute;
  "/order/$orderId/contents/": typeof PrivatePatient360OrderOrderIdContentsIndexRoute;
  "/bulk-bundle/$bulkBundleId/products/": typeof PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute;
  "/bulk-order/$bulkOrderId/contents/": typeof PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute;
  "/bulk-reorder/$bulkOrderId/schedule/": typeof PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute;
  "/stock-order/$stockOrderId/contents/": typeof PrivateStock360StockOrderStockOrderIdContentsIndexRoute;
  "/warehouse360-analytics/monthly-historic/": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof PrivateIndexRoute;
  "/auth": typeof AuthRouteRouteWithChildren;
  "/catalog-product": typeof PrivateCatalogProductRouteRouteWithChildren;
  "/product": typeof PrivateProductRouteRouteWithChildren;
  "/release-notes": typeof PrivateReleaseNotesRoute;
  "/mcp-login": typeof PublicMcpLoginRoute;
  "/privacy-policy": typeof PublicPrivacyPolicyRoute;
  "/terms-of-use": typeof PublicTermsOfUseRoute;
  "/auth/action": typeof AuthActionRoute;
  "/auth/forgot-password": typeof AuthForgotPasswordRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/mfa-challenge": typeof AuthMfaChallengeRoute;
  "/user": typeof PrivateAdminUserRouteRouteWithChildren;
  "/jobs": typeof PrivateAdminJobsRoute;
  "/calling": typeof PrivatePatient360CallingRoute;
  "/dispensing-overview": typeof PrivatePatient360DispensingOverviewRoute;
  "/texting": typeof PrivatePatient360TextingRoute;
  "/purchase-orders": typeof PrivateWarehouse360PurchaseOrdersRoute;
  "/catalog-product/create": typeof PrivateCatalogProductCreateRoute;
  "/catalog-product/lookup": typeof PrivateCatalogProductLookupRoute;
  "/product/bases": typeof PrivateProductBasesRoute;
  "/product/brands": typeof PrivateProductBrandsRoute;
  "/task/lookup": typeof PrivateTaskLookupRoute;
  "/instructions/$patientCampaignId": typeof PublicInstructionsPatientCampaignIdRoute;
  "/patient-payment-link/$patientPaymentLinkId": typeof PublicPatientPaymentLinkPatientPaymentLinkIdRoute;
  "/profile": typeof PrivateProfileIndexRoute;
  "/entity/create": typeof PrivateAdminEntityCreateRoute;
  "/entity/lookup": typeof PrivateAdminEntityLookupRoute;
  "/payor/create": typeof PrivateAdminPayorCreateRoute;
  "/payor/lookup": typeof PrivateAdminPayorLookupRoute;
  "/user/create": typeof PrivateAdminUserCreateRoute;
  "/user/lookup": typeof PrivateAdminUserLookupRoute;
  "/bulk-invoice/lookup": typeof PrivateBulkInvoiceBulkInvoiceLookupRoute;
  "/inventory-batch-log/lookup": typeof PrivateInventory360InventoryBatchLogLookupRoute;
  "/inventory/create": typeof PrivateInventory360InventoryCreateRoute;
  "/recall/create": typeof PrivateInventory360RecallCreateRoute;
  "/bundle/create": typeof PrivatePatient360BundleCreateRoute;
  "/bundle/lookup": typeof PrivatePatient360BundleLookupRoute;
  "/order/create": typeof PrivatePatient360OrderCreateRoute;
  "/order/lookup": typeof PrivatePatient360OrderLookupRoute;
  "/patient/create": typeof PrivatePatient360PatientCreateRoute;
  "/patient/lookup": typeof PrivatePatient360PatientLookupRoute;
  "/product/create": typeof PrivatePatientPharmcy360ProductCreateRoute;
  "/product/lookup": typeof PrivatePatientPharmcy360ProductLookupRoute;
  "/suborder/lookup": typeof PrivatePharmacy360SuborderLookupRoute;
  "/bulk-bundle/create": typeof PrivatePractice360BulkBundleCreateRoute;
  "/bulk-bundle/lookup": typeof PrivatePractice360BulkBundleLookupRoute;
  "/bulk-order/create": typeof PrivatePractice360BulkOrderCreateRoute;
  "/bulk-order/lookup": typeof PrivatePractice360BulkOrderLookupRoute;
  "/bulk-product/create": typeof PrivatePractice360BulkProductCreateRoute;
  "/bulk-product/lookup": typeof PrivatePractice360BulkProductLookupRoute;
  "/bulk-reorder/lookup": typeof PrivatePractice360BulkReorderLookupRoute;
  "/commissions/lookup": typeof PrivateSales360CommissionsLookupRoute;
  "/owned-stock/lookup": typeof PrivateStock360OwnedStockLookupRoute;
  "/stock-order/create": typeof PrivateStock360StockOrderCreateRoute;
  "/stock-order/lookup": typeof PrivateStock360StockOrderLookupRoute;
  "/batch/create": typeof PrivateWarehouse360BatchCreateRoute;
  "/batch/lookup": typeof PrivateWarehouse360BatchLookupRoute;
  "/vendor/create": typeof PrivateWarehouse360VendorCreateRoute;
  "/vendor/lookup": typeof PrivateWarehouse360VendorLookupRoute;
  "/warehouse-vendor/create": typeof PrivateWarehouse360WarehouseVendorCreateRoute;
  "/warehouse/create": typeof PrivateWarehouse360WarehouseCreateRoute;
  "/warehouse/lookup": typeof PrivateWarehouse360WarehouseLookupRoute;
  "/catalog-product/$catalogProductId/edit": typeof PrivateCatalogProductCatalogProductIdEditRoute;
  "/ai-chat": typeof PrivateAdminAiChatIndexRoute;
  "/best-rx": typeof PrivateAdminBestRxIndexRoute;
  "/fulfillment360-analytics": typeof PrivateFulfillment360Fulfillment360AnalyticsIndexRoute;
  "/patient360-analytics": typeof PrivatePatient360Patient360AnalyticsIndexRoute;
  "/pharmacy360-analytics": typeof PrivatePharmacy360Pharmacy360AnalyticsIndexRoute;
  "/catalog-product/$catalogProductId": typeof PrivateCatalogProductCatalogProductIdIndexRoute;
  "/entity/$entityId": typeof PrivateEntityEntityIdIndexRoute;
  "/product/treatments": typeof PrivateProductTreatmentsIndexRoute;
  "/entity/$entityId/edit": typeof PrivateAdminEntityEntityIdEditRoute;
  "/payor/$payorId/edit": typeof PrivateAdminPayorPayorIdEditRoute;
  "/user/$userId/edit": typeof PrivateAdminUserUserIdEditRoute;
  "/inventory/$inventoryId/edit": typeof PrivateInventory360InventoryInventoryIdEditRoute;
  "/bundle/$bundleId/edit": typeof PrivatePatient360BundleBundleIdEditRoute;
  "/order/$orderId/edit": typeof PrivatePatient360OrderOrderIdEditRoute;
  "/product/$productId/edit": typeof PrivatePatientPharmcy360ProductProductIdEditRoute;
  "/bulk-bundle/$bulkBundleId/edit": typeof PrivatePractice360BulkBundleBulkBundleIdEditRoute;
  "/bulk-order/$bulkOrderId/edit": typeof PrivatePractice360BulkOrderBulkOrderIdEditRoute;
  "/bulk-product/$bulkProductId/edit": typeof PrivatePractice360BulkProductBulkProductIdEditRoute;
  "/stock-order/$stockOrderId/edit": typeof PrivateStock360StockOrderStockOrderIdEditRoute;
  "/batch/$batchId/edit": typeof PrivateWarehouse360BatchBatchIdEditRoute;
  "/vendor/$vendorId/edit": typeof PrivateWarehouse360VendorVendorIdEditRoute;
  "/warehouse-vendor/$warehouseVendorId/edit": typeof PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute;
  "/warehouse/$warehouseId/edit": typeof PrivateWarehouse360WarehouseWarehouseIdEditRoute;
  "/payor/$payorId": typeof PrivateAdminPayorPayorIdIndexRoute;
  "/user/$userId": typeof PrivateAdminUserUserIdIndexRoute;
  "/bulk-invoice/$bulkInvoiceId": typeof PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute;
  "/bulk-suborder/$bulkSuborderId": typeof PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute;
  "/bulk-suborder/lookup": typeof PrivateFulfillment360BulkSuborderLookupIndexRoute;
  "/inventory-lot/lookup": typeof PrivateInventory360InventoryLotLookupIndexRoute;
  "/inventory-vendor/lookup": typeof PrivateInventory360InventoryVendorLookupIndexRoute;
  "/inventory/$inventoryId": typeof PrivateInventory360InventoryInventoryIdIndexRoute;
  "/inventory/lookup": typeof PrivateInventory360InventoryLookupIndexRoute;
  "/recall/$recallEventId": typeof PrivateInventory360RecallRecallEventIdIndexRoute;
  "/recall/lookup": typeof PrivateInventory360RecallLookupIndexRoute;
  "/bundle/$bundleId": typeof PrivatePatient360BundleBundleIdIndexRoute;
  "/order/$orderId": typeof PrivatePatient360OrderOrderIdIndexRoute;
  "/patient/$patientId": typeof PrivatePatient360PatientPatientIdIndexRoute;
  "/product/$productId": typeof PrivatePatientPharmcy360ProductProductIdIndexRoute;
  "/suborder/$suborderId": typeof PrivatePharmacy360SuborderSuborderIdIndexRoute;
  "/bulk-bundle/$bulkBundleId": typeof PrivatePractice360BulkBundleBulkBundleIdIndexRoute;
  "/bulk-order/$bulkOrderId": typeof PrivatePractice360BulkOrderBulkOrderIdIndexRoute;
  "/bulk-product/$bulkProductId": typeof PrivatePractice360BulkProductBulkProductIdIndexRoute;
  "/owned-stock/$catalogProductId": typeof PrivateStock360OwnedStockCatalogProductIdIndexRoute;
  "/stock-order/$stockOrderId": typeof PrivateStock360StockOrderStockOrderIdIndexRoute;
  "/warehouse360-analytics": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute;
  "/batch/$batchId": typeof PrivateWarehouse360BatchBatchIdIndexRoute;
  "/vendor/$vendorId": typeof PrivateWarehouse360VendorVendorIdIndexRoute;
  "/warehouse/$warehouseId": typeof PrivateWarehouse360WarehouseWarehouseIdIndexRoute;
  "/catalog-product/$catalogProductId/components": typeof PrivateCatalogProductCatalogProductIdComponentsIndexRoute;
  "/inventory/$inventoryId/lot/$lotNumber": typeof PrivateInventory360InventoryInventoryIdLotLotNumberRoute;
  "/inventory/$inventoryId/lot/unassigned": typeof PrivateInventory360InventoryInventoryIdLotUnassignedRoute;
  "/patient/$patientId/create/address": typeof PrivatePatient360PatientPatientIdCreateAddressRoute;
  "/patient/$patientId/create/patient-payor": typeof PrivatePatient360PatientPatientIdCreatePatientPayorRoute;
  "/patient/$patientId/create/payment": typeof PrivatePatient360PatientPatientIdCreatePaymentRoute;
  "/entity/$entityId/services": typeof PrivateAdminEntityEntityIdServicesIndexRoute;
  "/entity/$entityId/visibility": typeof PrivateAdminEntityEntityIdVisibilityIndexRoute;
  "/user/$userId/commissions": typeof PrivateAdminUserUserIdCommissionsIndexRoute;
  "/user/$userId/entities": typeof PrivateAdminUserUserIdEntitiesIndexRoute;
  "/user/$userId/permissions": typeof PrivateAdminUserUserIdPermissionsIndexRoute;
  "/bundle/$bundleId/products": typeof PrivatePatient360BundleBundleIdProductsIndexRoute;
  "/order/$orderId/contents": typeof PrivatePatient360OrderOrderIdContentsIndexRoute;
  "/bulk-bundle/$bulkBundleId/products": typeof PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute;
  "/bulk-order/$bulkOrderId/contents": typeof PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute;
  "/bulk-reorder/$bulkOrderId/schedule": typeof PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute;
  "/stock-order/$stockOrderId/contents": typeof PrivateStock360StockOrderStockOrderIdContentsIndexRoute;
  "/warehouse360-analytics/monthly-historic": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_private": typeof PrivateRouteRouteWithChildren;
  "/_public": typeof PublicRouteRouteWithChildren;
  "/auth": typeof AuthRouteRouteWithChildren;
  "/_private/_admin": typeof PrivateAdminRouteRouteWithChildren;
  "/_private/_bulk-invoice": typeof PrivateBulkInvoiceRouteRouteWithChildren;
  "/_private/_fulfillment-360": typeof PrivateFulfillment360RouteRouteWithChildren;
  "/_private/_inventory-360": typeof PrivateInventory360RouteRouteWithChildren;
  "/_private/_patient-360": typeof PrivatePatient360RouteRouteWithChildren;
  "/_private/_patient-pharmcy-360": typeof PrivatePatientPharmcy360RouteRouteWithChildren;
  "/_private/_pharmacy-360": typeof PrivatePharmacy360RouteRouteWithChildren;
  "/_private/_practice-360": typeof PrivatePractice360RouteRouteWithChildren;
  "/_private/_sales-360": typeof PrivateSales360RouteRouteWithChildren;
  "/_private/_stock-360": typeof PrivateStock360RouteRouteWithChildren;
  "/_private/_warehouse-360": typeof PrivateWarehouse360RouteRouteWithChildren;
  "/_private/catalog-product": typeof PrivateCatalogProductRouteRouteWithChildren;
  "/_private/product": typeof PrivateProductRouteRouteWithChildren;
  "/_private/release-notes": typeof PrivateReleaseNotesRoute;
  "/_public/mcp-login": typeof PublicMcpLoginRoute;
  "/_public/privacy-policy": typeof PublicPrivacyPolicyRoute;
  "/_public/terms-of-use": typeof PublicTermsOfUseRoute;
  "/auth/action": typeof AuthActionRoute;
  "/auth/forgot-password": typeof AuthForgotPasswordRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/mfa-challenge": typeof AuthMfaChallengeRoute;
  "/_private/": typeof PrivateIndexRoute;
  "/_private/_admin/user": typeof PrivateAdminUserRouteRouteWithChildren;
  "/_private/_warehouse-360/_analytics": typeof PrivateWarehouse360AnalyticsRouteRouteWithChildren;
  "/_private/_admin/jobs": typeof PrivateAdminJobsRoute;
  "/_private/_patient-360/calling": typeof PrivatePatient360CallingRoute;
  "/_private/_patient-360/dispensing-overview": typeof PrivatePatient360DispensingOverviewRoute;
  "/_private/_patient-360/texting": typeof PrivatePatient360TextingRoute;
  "/_private/_warehouse-360/purchase-orders": typeof PrivateWarehouse360PurchaseOrdersRoute;
  "/_private/catalog-product/create": typeof PrivateCatalogProductCreateRoute;
  "/_private/catalog-product/lookup": typeof PrivateCatalogProductLookupRoute;
  "/_private/product/bases": typeof PrivateProductBasesRoute;
  "/_private/product/brands": typeof PrivateProductBrandsRoute;
  "/_private/task/lookup": typeof PrivateTaskLookupRoute;
  "/_public/instructions/$patientCampaignId": typeof PublicInstructionsPatientCampaignIdRoute;
  "/_public/patient-payment-link/$patientPaymentLinkId": typeof PublicPatientPaymentLinkPatientPaymentLinkIdRoute;
  "/_private/profile/": typeof PrivateProfileIndexRoute;
  "/_private/_admin/entity/create": typeof PrivateAdminEntityCreateRoute;
  "/_private/_admin/entity/lookup": typeof PrivateAdminEntityLookupRoute;
  "/_private/_admin/payor/create": typeof PrivateAdminPayorCreateRoute;
  "/_private/_admin/payor/lookup": typeof PrivateAdminPayorLookupRoute;
  "/_private/_admin/user/create": typeof PrivateAdminUserCreateRoute;
  "/_private/_admin/user/lookup": typeof PrivateAdminUserLookupRoute;
  "/_private/_bulk-invoice/bulk-invoice/lookup": typeof PrivateBulkInvoiceBulkInvoiceLookupRoute;
  "/_private/_inventory-360/inventory-batch-log/lookup": typeof PrivateInventory360InventoryBatchLogLookupRoute;
  "/_private/_inventory-360/inventory/create": typeof PrivateInventory360InventoryCreateRoute;
  "/_private/_inventory-360/recall/create": typeof PrivateInventory360RecallCreateRoute;
  "/_private/_patient-360/bundle/create": typeof PrivatePatient360BundleCreateRoute;
  "/_private/_patient-360/bundle/lookup": typeof PrivatePatient360BundleLookupRoute;
  "/_private/_patient-360/order/create": typeof PrivatePatient360OrderCreateRoute;
  "/_private/_patient-360/order/lookup": typeof PrivatePatient360OrderLookupRoute;
  "/_private/_patient-360/patient/create": typeof PrivatePatient360PatientCreateRoute;
  "/_private/_patient-360/patient/lookup": typeof PrivatePatient360PatientLookupRoute;
  "/_private/_patient-pharmcy-360/product/create": typeof PrivatePatientPharmcy360ProductCreateRoute;
  "/_private/_patient-pharmcy-360/product/lookup": typeof PrivatePatientPharmcy360ProductLookupRoute;
  "/_private/_pharmacy-360/suborder/lookup": typeof PrivatePharmacy360SuborderLookupRoute;
  "/_private/_practice-360/bulk-bundle/create": typeof PrivatePractice360BulkBundleCreateRoute;
  "/_private/_practice-360/bulk-bundle/lookup": typeof PrivatePractice360BulkBundleLookupRoute;
  "/_private/_practice-360/bulk-order/create": typeof PrivatePractice360BulkOrderCreateRoute;
  "/_private/_practice-360/bulk-order/lookup": typeof PrivatePractice360BulkOrderLookupRoute;
  "/_private/_practice-360/bulk-product/create": typeof PrivatePractice360BulkProductCreateRoute;
  "/_private/_practice-360/bulk-product/lookup": typeof PrivatePractice360BulkProductLookupRoute;
  "/_private/_practice-360/bulk-reorder/lookup": typeof PrivatePractice360BulkReorderLookupRoute;
  "/_private/_sales-360/commissions/lookup": typeof PrivateSales360CommissionsLookupRoute;
  "/_private/_stock-360/owned-stock/lookup": typeof PrivateStock360OwnedStockLookupRoute;
  "/_private/_stock-360/stock-order/create": typeof PrivateStock360StockOrderCreateRoute;
  "/_private/_stock-360/stock-order/lookup": typeof PrivateStock360StockOrderLookupRoute;
  "/_private/_warehouse-360/batch/create": typeof PrivateWarehouse360BatchCreateRoute;
  "/_private/_warehouse-360/batch/lookup": typeof PrivateWarehouse360BatchLookupRoute;
  "/_private/_warehouse-360/vendor/create": typeof PrivateWarehouse360VendorCreateRoute;
  "/_private/_warehouse-360/vendor/lookup": typeof PrivateWarehouse360VendorLookupRoute;
  "/_private/_warehouse-360/warehouse-vendor/create": typeof PrivateWarehouse360WarehouseVendorCreateRoute;
  "/_private/_warehouse-360/warehouse/create": typeof PrivateWarehouse360WarehouseCreateRoute;
  "/_private/_warehouse-360/warehouse/lookup": typeof PrivateWarehouse360WarehouseLookupRoute;
  "/_private/catalog-product/$catalogProductId/edit": typeof PrivateCatalogProductCatalogProductIdEditRoute;
  "/_private/_admin/ai-chat/": typeof PrivateAdminAiChatIndexRoute;
  "/_private/_admin/best-rx/": typeof PrivateAdminBestRxIndexRoute;
  "/_private/_fulfillment-360/fulfillment360-analytics/": typeof PrivateFulfillment360Fulfillment360AnalyticsIndexRoute;
  "/_private/_patient-360/patient360-analytics/": typeof PrivatePatient360Patient360AnalyticsIndexRoute;
  "/_private/_pharmacy-360/pharmacy360-analytics/": typeof PrivatePharmacy360Pharmacy360AnalyticsIndexRoute;
  "/_private/catalog-product/$catalogProductId/": typeof PrivateCatalogProductCatalogProductIdIndexRoute;
  "/_private/entity/$entityId/": typeof PrivateEntityEntityIdIndexRoute;
  "/_private/product/treatments/": typeof PrivateProductTreatmentsIndexRoute;
  "/_private/_admin/entity/$entityId/edit": typeof PrivateAdminEntityEntityIdEditRoute;
  "/_private/_admin/payor/$payorId/edit": typeof PrivateAdminPayorPayorIdEditRoute;
  "/_private/_admin/user/$userId/edit": typeof PrivateAdminUserUserIdEditRoute;
  "/_private/_inventory-360/inventory/$inventoryId/edit": typeof PrivateInventory360InventoryInventoryIdEditRoute;
  "/_private/_patient-360/bundle/$bundleId/edit": typeof PrivatePatient360BundleBundleIdEditRoute;
  "/_private/_patient-360/order/$orderId/edit": typeof PrivatePatient360OrderOrderIdEditRoute;
  "/_private/_patient-pharmcy-360/product/$productId/edit": typeof PrivatePatientPharmcy360ProductProductIdEditRoute;
  "/_private/_practice-360/bulk-bundle/$bulkBundleId/edit": typeof PrivatePractice360BulkBundleBulkBundleIdEditRoute;
  "/_private/_practice-360/bulk-order/$bulkOrderId/edit": typeof PrivatePractice360BulkOrderBulkOrderIdEditRoute;
  "/_private/_practice-360/bulk-product/$bulkProductId/edit": typeof PrivatePractice360BulkProductBulkProductIdEditRoute;
  "/_private/_stock-360/stock-order/$stockOrderId/edit": typeof PrivateStock360StockOrderStockOrderIdEditRoute;
  "/_private/_warehouse-360/batch/$batchId/edit": typeof PrivateWarehouse360BatchBatchIdEditRoute;
  "/_private/_warehouse-360/vendor/$vendorId/edit": typeof PrivateWarehouse360VendorVendorIdEditRoute;
  "/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit": typeof PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute;
  "/_private/_warehouse-360/warehouse/$warehouseId/edit": typeof PrivateWarehouse360WarehouseWarehouseIdEditRoute;
  "/_private/_admin/payor/$payorId/": typeof PrivateAdminPayorPayorIdIndexRoute;
  "/_private/_admin/user/$userId/": typeof PrivateAdminUserUserIdIndexRoute;
  "/_private/_bulk-invoice/bulk-invoice/$bulkInvoiceId/": typeof PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute;
  "/_private/_fulfillment-360/bulk-suborder/$bulkSuborderId/": typeof PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute;
  "/_private/_fulfillment-360/bulk-suborder/lookup/": typeof PrivateFulfillment360BulkSuborderLookupIndexRoute;
  "/_private/_inventory-360/inventory-lot/lookup/": typeof PrivateInventory360InventoryLotLookupIndexRoute;
  "/_private/_inventory-360/inventory-vendor/lookup/": typeof PrivateInventory360InventoryVendorLookupIndexRoute;
  "/_private/_inventory-360/inventory/$inventoryId/": typeof PrivateInventory360InventoryInventoryIdIndexRoute;
  "/_private/_inventory-360/inventory/lookup/": typeof PrivateInventory360InventoryLookupIndexRoute;
  "/_private/_inventory-360/recall/$recallEventId/": typeof PrivateInventory360RecallRecallEventIdIndexRoute;
  "/_private/_inventory-360/recall/lookup/": typeof PrivateInventory360RecallLookupIndexRoute;
  "/_private/_patient-360/bundle/$bundleId/": typeof PrivatePatient360BundleBundleIdIndexRoute;
  "/_private/_patient-360/order/$orderId/": typeof PrivatePatient360OrderOrderIdIndexRoute;
  "/_private/_patient-360/patient/$patientId/": typeof PrivatePatient360PatientPatientIdIndexRoute;
  "/_private/_patient-pharmcy-360/product/$productId/": typeof PrivatePatientPharmcy360ProductProductIdIndexRoute;
  "/_private/_pharmacy-360/suborder/$suborderId/": typeof PrivatePharmacy360SuborderSuborderIdIndexRoute;
  "/_private/_practice-360/bulk-bundle/$bulkBundleId/": typeof PrivatePractice360BulkBundleBulkBundleIdIndexRoute;
  "/_private/_practice-360/bulk-order/$bulkOrderId/": typeof PrivatePractice360BulkOrderBulkOrderIdIndexRoute;
  "/_private/_practice-360/bulk-product/$bulkProductId/": typeof PrivatePractice360BulkProductBulkProductIdIndexRoute;
  "/_private/_stock-360/owned-stock/$catalogProductId/": typeof PrivateStock360OwnedStockCatalogProductIdIndexRoute;
  "/_private/_stock-360/stock-order/$stockOrderId/": typeof PrivateStock360StockOrderStockOrderIdIndexRoute;
  "/_private/_warehouse-360/_analytics/warehouse360-analytics/": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute;
  "/_private/_warehouse-360/batch/$batchId/": typeof PrivateWarehouse360BatchBatchIdIndexRoute;
  "/_private/_warehouse-360/vendor/$vendorId/": typeof PrivateWarehouse360VendorVendorIdIndexRoute;
  "/_private/_warehouse-360/warehouse/$warehouseId/": typeof PrivateWarehouse360WarehouseWarehouseIdIndexRoute;
  "/_private/catalog-product/$catalogProductId/components/": typeof PrivateCatalogProductCatalogProductIdComponentsIndexRoute;
  "/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber": typeof PrivateInventory360InventoryInventoryIdLotLotNumberRoute;
  "/_private/_inventory-360/inventory/$inventoryId/lot/unassigned": typeof PrivateInventory360InventoryInventoryIdLotUnassignedRoute;
  "/_private/_patient-360/patient/$patientId/create/address": typeof PrivatePatient360PatientPatientIdCreateAddressRoute;
  "/_private/_patient-360/patient/$patientId/create/patient-payor": typeof PrivatePatient360PatientPatientIdCreatePatientPayorRoute;
  "/_private/_patient-360/patient/$patientId/create/payment": typeof PrivatePatient360PatientPatientIdCreatePaymentRoute;
  "/_private/_admin/entity/$entityId/services/": typeof PrivateAdminEntityEntityIdServicesIndexRoute;
  "/_private/_admin/entity/$entityId/visibility/": typeof PrivateAdminEntityEntityIdVisibilityIndexRoute;
  "/_private/_admin/user/$userId/commissions/": typeof PrivateAdminUserUserIdCommissionsIndexRoute;
  "/_private/_admin/user/$userId/entities/": typeof PrivateAdminUserUserIdEntitiesIndexRoute;
  "/_private/_admin/user/$userId/permissions/": typeof PrivateAdminUserUserIdPermissionsIndexRoute;
  "/_private/_patient-360/bundle/$bundleId/products/": typeof PrivatePatient360BundleBundleIdProductsIndexRoute;
  "/_private/_patient-360/order/$orderId/contents/": typeof PrivatePatient360OrderOrderIdContentsIndexRoute;
  "/_private/_practice-360/bulk-bundle/$bulkBundleId/products/": typeof PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute;
  "/_private/_practice-360/bulk-order/$bulkOrderId/contents/": typeof PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute;
  "/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/": typeof PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute;
  "/_private/_stock-360/stock-order/$stockOrderId/contents/": typeof PrivateStock360StockOrderStockOrderIdContentsIndexRoute;
  "/_private/_warehouse-360/_analytics/warehouse360-analytics/monthly-historic/": typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/auth"
    | "/catalog-product"
    | "/product"
    | "/release-notes"
    | "/mcp-login"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/auth/action"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/mfa-challenge"
    | "/user"
    | "/jobs"
    | "/calling"
    | "/dispensing-overview"
    | "/texting"
    | "/purchase-orders"
    | "/catalog-product/create"
    | "/catalog-product/lookup"
    | "/product/bases"
    | "/product/brands"
    | "/task/lookup"
    | "/instructions/$patientCampaignId"
    | "/patient-payment-link/$patientPaymentLinkId"
    | "/profile/"
    | "/entity/create"
    | "/entity/lookup"
    | "/payor/create"
    | "/payor/lookup"
    | "/user/create"
    | "/user/lookup"
    | "/bulk-invoice/lookup"
    | "/inventory-batch-log/lookup"
    | "/inventory/create"
    | "/recall/create"
    | "/bundle/create"
    | "/bundle/lookup"
    | "/order/create"
    | "/order/lookup"
    | "/patient/create"
    | "/patient/lookup"
    | "/product/create"
    | "/product/lookup"
    | "/suborder/lookup"
    | "/bulk-bundle/create"
    | "/bulk-bundle/lookup"
    | "/bulk-order/create"
    | "/bulk-order/lookup"
    | "/bulk-product/create"
    | "/bulk-product/lookup"
    | "/bulk-reorder/lookup"
    | "/commissions/lookup"
    | "/owned-stock/lookup"
    | "/stock-order/create"
    | "/stock-order/lookup"
    | "/batch/create"
    | "/batch/lookup"
    | "/vendor/create"
    | "/vendor/lookup"
    | "/warehouse-vendor/create"
    | "/warehouse/create"
    | "/warehouse/lookup"
    | "/catalog-product/$catalogProductId/edit"
    | "/ai-chat/"
    | "/best-rx/"
    | "/fulfillment360-analytics/"
    | "/patient360-analytics/"
    | "/pharmacy360-analytics/"
    | "/catalog-product/$catalogProductId/"
    | "/entity/$entityId/"
    | "/product/treatments/"
    | "/entity/$entityId/edit"
    | "/payor/$payorId/edit"
    | "/user/$userId/edit"
    | "/inventory/$inventoryId/edit"
    | "/bundle/$bundleId/edit"
    | "/order/$orderId/edit"
    | "/product/$productId/edit"
    | "/bulk-bundle/$bulkBundleId/edit"
    | "/bulk-order/$bulkOrderId/edit"
    | "/bulk-product/$bulkProductId/edit"
    | "/stock-order/$stockOrderId/edit"
    | "/batch/$batchId/edit"
    | "/vendor/$vendorId/edit"
    | "/warehouse-vendor/$warehouseVendorId/edit"
    | "/warehouse/$warehouseId/edit"
    | "/payor/$payorId/"
    | "/user/$userId/"
    | "/bulk-invoice/$bulkInvoiceId/"
    | "/bulk-suborder/$bulkSuborderId/"
    | "/bulk-suborder/lookup/"
    | "/inventory-lot/lookup/"
    | "/inventory-vendor/lookup/"
    | "/inventory/$inventoryId/"
    | "/inventory/lookup/"
    | "/recall/$recallEventId/"
    | "/recall/lookup/"
    | "/bundle/$bundleId/"
    | "/order/$orderId/"
    | "/patient/$patientId/"
    | "/product/$productId/"
    | "/suborder/$suborderId/"
    | "/bulk-bundle/$bulkBundleId/"
    | "/bulk-order/$bulkOrderId/"
    | "/bulk-product/$bulkProductId/"
    | "/owned-stock/$catalogProductId/"
    | "/stock-order/$stockOrderId/"
    | "/warehouse360-analytics/"
    | "/batch/$batchId/"
    | "/vendor/$vendorId/"
    | "/warehouse/$warehouseId/"
    | "/catalog-product/$catalogProductId/components/"
    | "/inventory/$inventoryId/lot/$lotNumber"
    | "/inventory/$inventoryId/lot/unassigned"
    | "/patient/$patientId/create/address"
    | "/patient/$patientId/create/patient-payor"
    | "/patient/$patientId/create/payment"
    | "/entity/$entityId/services/"
    | "/entity/$entityId/visibility/"
    | "/user/$userId/commissions/"
    | "/user/$userId/entities/"
    | "/user/$userId/permissions/"
    | "/bundle/$bundleId/products/"
    | "/order/$orderId/contents/"
    | "/bulk-bundle/$bulkBundleId/products/"
    | "/bulk-order/$bulkOrderId/contents/"
    | "/bulk-reorder/$bulkOrderId/schedule/"
    | "/stock-order/$stockOrderId/contents/"
    | "/warehouse360-analytics/monthly-historic/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/auth"
    | "/catalog-product"
    | "/product"
    | "/release-notes"
    | "/mcp-login"
    | "/privacy-policy"
    | "/terms-of-use"
    | "/auth/action"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/mfa-challenge"
    | "/user"
    | "/jobs"
    | "/calling"
    | "/dispensing-overview"
    | "/texting"
    | "/purchase-orders"
    | "/catalog-product/create"
    | "/catalog-product/lookup"
    | "/product/bases"
    | "/product/brands"
    | "/task/lookup"
    | "/instructions/$patientCampaignId"
    | "/patient-payment-link/$patientPaymentLinkId"
    | "/profile"
    | "/entity/create"
    | "/entity/lookup"
    | "/payor/create"
    | "/payor/lookup"
    | "/user/create"
    | "/user/lookup"
    | "/bulk-invoice/lookup"
    | "/inventory-batch-log/lookup"
    | "/inventory/create"
    | "/recall/create"
    | "/bundle/create"
    | "/bundle/lookup"
    | "/order/create"
    | "/order/lookup"
    | "/patient/create"
    | "/patient/lookup"
    | "/product/create"
    | "/product/lookup"
    | "/suborder/lookup"
    | "/bulk-bundle/create"
    | "/bulk-bundle/lookup"
    | "/bulk-order/create"
    | "/bulk-order/lookup"
    | "/bulk-product/create"
    | "/bulk-product/lookup"
    | "/bulk-reorder/lookup"
    | "/commissions/lookup"
    | "/owned-stock/lookup"
    | "/stock-order/create"
    | "/stock-order/lookup"
    | "/batch/create"
    | "/batch/lookup"
    | "/vendor/create"
    | "/vendor/lookup"
    | "/warehouse-vendor/create"
    | "/warehouse/create"
    | "/warehouse/lookup"
    | "/catalog-product/$catalogProductId/edit"
    | "/ai-chat"
    | "/best-rx"
    | "/fulfillment360-analytics"
    | "/patient360-analytics"
    | "/pharmacy360-analytics"
    | "/catalog-product/$catalogProductId"
    | "/entity/$entityId"
    | "/product/treatments"
    | "/entity/$entityId/edit"
    | "/payor/$payorId/edit"
    | "/user/$userId/edit"
    | "/inventory/$inventoryId/edit"
    | "/bundle/$bundleId/edit"
    | "/order/$orderId/edit"
    | "/product/$productId/edit"
    | "/bulk-bundle/$bulkBundleId/edit"
    | "/bulk-order/$bulkOrderId/edit"
    | "/bulk-product/$bulkProductId/edit"
    | "/stock-order/$stockOrderId/edit"
    | "/batch/$batchId/edit"
    | "/vendor/$vendorId/edit"
    | "/warehouse-vendor/$warehouseVendorId/edit"
    | "/warehouse/$warehouseId/edit"
    | "/payor/$payorId"
    | "/user/$userId"
    | "/bulk-invoice/$bulkInvoiceId"
    | "/bulk-suborder/$bulkSuborderId"
    | "/bulk-suborder/lookup"
    | "/inventory-lot/lookup"
    | "/inventory-vendor/lookup"
    | "/inventory/$inventoryId"
    | "/inventory/lookup"
    | "/recall/$recallEventId"
    | "/recall/lookup"
    | "/bundle/$bundleId"
    | "/order/$orderId"
    | "/patient/$patientId"
    | "/product/$productId"
    | "/suborder/$suborderId"
    | "/bulk-bundle/$bulkBundleId"
    | "/bulk-order/$bulkOrderId"
    | "/bulk-product/$bulkProductId"
    | "/owned-stock/$catalogProductId"
    | "/stock-order/$stockOrderId"
    | "/warehouse360-analytics"
    | "/batch/$batchId"
    | "/vendor/$vendorId"
    | "/warehouse/$warehouseId"
    | "/catalog-product/$catalogProductId/components"
    | "/inventory/$inventoryId/lot/$lotNumber"
    | "/inventory/$inventoryId/lot/unassigned"
    | "/patient/$patientId/create/address"
    | "/patient/$patientId/create/patient-payor"
    | "/patient/$patientId/create/payment"
    | "/entity/$entityId/services"
    | "/entity/$entityId/visibility"
    | "/user/$userId/commissions"
    | "/user/$userId/entities"
    | "/user/$userId/permissions"
    | "/bundle/$bundleId/products"
    | "/order/$orderId/contents"
    | "/bulk-bundle/$bulkBundleId/products"
    | "/bulk-order/$bulkOrderId/contents"
    | "/bulk-reorder/$bulkOrderId/schedule"
    | "/stock-order/$stockOrderId/contents"
    | "/warehouse360-analytics/monthly-historic";
  id:
    | "__root__"
    | "/_private"
    | "/_public"
    | "/auth"
    | "/_private/_admin"
    | "/_private/_bulk-invoice"
    | "/_private/_fulfillment-360"
    | "/_private/_inventory-360"
    | "/_private/_patient-360"
    | "/_private/_patient-pharmcy-360"
    | "/_private/_pharmacy-360"
    | "/_private/_practice-360"
    | "/_private/_sales-360"
    | "/_private/_stock-360"
    | "/_private/_warehouse-360"
    | "/_private/catalog-product"
    | "/_private/product"
    | "/_private/release-notes"
    | "/_public/mcp-login"
    | "/_public/privacy-policy"
    | "/_public/terms-of-use"
    | "/auth/action"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/mfa-challenge"
    | "/_private/"
    | "/_private/_admin/user"
    | "/_private/_warehouse-360/_analytics"
    | "/_private/_admin/jobs"
    | "/_private/_patient-360/calling"
    | "/_private/_patient-360/dispensing-overview"
    | "/_private/_patient-360/texting"
    | "/_private/_warehouse-360/purchase-orders"
    | "/_private/catalog-product/create"
    | "/_private/catalog-product/lookup"
    | "/_private/product/bases"
    | "/_private/product/brands"
    | "/_private/task/lookup"
    | "/_public/instructions/$patientCampaignId"
    | "/_public/patient-payment-link/$patientPaymentLinkId"
    | "/_private/profile/"
    | "/_private/_admin/entity/create"
    | "/_private/_admin/entity/lookup"
    | "/_private/_admin/payor/create"
    | "/_private/_admin/payor/lookup"
    | "/_private/_admin/user/create"
    | "/_private/_admin/user/lookup"
    | "/_private/_bulk-invoice/bulk-invoice/lookup"
    | "/_private/_inventory-360/inventory-batch-log/lookup"
    | "/_private/_inventory-360/inventory/create"
    | "/_private/_inventory-360/recall/create"
    | "/_private/_patient-360/bundle/create"
    | "/_private/_patient-360/bundle/lookup"
    | "/_private/_patient-360/order/create"
    | "/_private/_patient-360/order/lookup"
    | "/_private/_patient-360/patient/create"
    | "/_private/_patient-360/patient/lookup"
    | "/_private/_patient-pharmcy-360/product/create"
    | "/_private/_patient-pharmcy-360/product/lookup"
    | "/_private/_pharmacy-360/suborder/lookup"
    | "/_private/_practice-360/bulk-bundle/create"
    | "/_private/_practice-360/bulk-bundle/lookup"
    | "/_private/_practice-360/bulk-order/create"
    | "/_private/_practice-360/bulk-order/lookup"
    | "/_private/_practice-360/bulk-product/create"
    | "/_private/_practice-360/bulk-product/lookup"
    | "/_private/_practice-360/bulk-reorder/lookup"
    | "/_private/_sales-360/commissions/lookup"
    | "/_private/_stock-360/owned-stock/lookup"
    | "/_private/_stock-360/stock-order/create"
    | "/_private/_stock-360/stock-order/lookup"
    | "/_private/_warehouse-360/batch/create"
    | "/_private/_warehouse-360/batch/lookup"
    | "/_private/_warehouse-360/vendor/create"
    | "/_private/_warehouse-360/vendor/lookup"
    | "/_private/_warehouse-360/warehouse-vendor/create"
    | "/_private/_warehouse-360/warehouse/create"
    | "/_private/_warehouse-360/warehouse/lookup"
    | "/_private/catalog-product/$catalogProductId/edit"
    | "/_private/_admin/ai-chat/"
    | "/_private/_admin/best-rx/"
    | "/_private/_fulfillment-360/fulfillment360-analytics/"
    | "/_private/_patient-360/patient360-analytics/"
    | "/_private/_pharmacy-360/pharmacy360-analytics/"
    | "/_private/catalog-product/$catalogProductId/"
    | "/_private/entity/$entityId/"
    | "/_private/product/treatments/"
    | "/_private/_admin/entity/$entityId/edit"
    | "/_private/_admin/payor/$payorId/edit"
    | "/_private/_admin/user/$userId/edit"
    | "/_private/_inventory-360/inventory/$inventoryId/edit"
    | "/_private/_patient-360/bundle/$bundleId/edit"
    | "/_private/_patient-360/order/$orderId/edit"
    | "/_private/_patient-pharmcy-360/product/$productId/edit"
    | "/_private/_practice-360/bulk-bundle/$bulkBundleId/edit"
    | "/_private/_practice-360/bulk-order/$bulkOrderId/edit"
    | "/_private/_practice-360/bulk-product/$bulkProductId/edit"
    | "/_private/_stock-360/stock-order/$stockOrderId/edit"
    | "/_private/_warehouse-360/batch/$batchId/edit"
    | "/_private/_warehouse-360/vendor/$vendorId/edit"
    | "/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit"
    | "/_private/_warehouse-360/warehouse/$warehouseId/edit"
    | "/_private/_admin/payor/$payorId/"
    | "/_private/_admin/user/$userId/"
    | "/_private/_bulk-invoice/bulk-invoice/$bulkInvoiceId/"
    | "/_private/_fulfillment-360/bulk-suborder/$bulkSuborderId/"
    | "/_private/_fulfillment-360/bulk-suborder/lookup/"
    | "/_private/_inventory-360/inventory-lot/lookup/"
    | "/_private/_inventory-360/inventory-vendor/lookup/"
    | "/_private/_inventory-360/inventory/$inventoryId/"
    | "/_private/_inventory-360/inventory/lookup/"
    | "/_private/_inventory-360/recall/$recallEventId/"
    | "/_private/_inventory-360/recall/lookup/"
    | "/_private/_patient-360/bundle/$bundleId/"
    | "/_private/_patient-360/order/$orderId/"
    | "/_private/_patient-360/patient/$patientId/"
    | "/_private/_patient-pharmcy-360/product/$productId/"
    | "/_private/_pharmacy-360/suborder/$suborderId/"
    | "/_private/_practice-360/bulk-bundle/$bulkBundleId/"
    | "/_private/_practice-360/bulk-order/$bulkOrderId/"
    | "/_private/_practice-360/bulk-product/$bulkProductId/"
    | "/_private/_stock-360/owned-stock/$catalogProductId/"
    | "/_private/_stock-360/stock-order/$stockOrderId/"
    | "/_private/_warehouse-360/_analytics/warehouse360-analytics/"
    | "/_private/_warehouse-360/batch/$batchId/"
    | "/_private/_warehouse-360/vendor/$vendorId/"
    | "/_private/_warehouse-360/warehouse/$warehouseId/"
    | "/_private/catalog-product/$catalogProductId/components/"
    | "/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber"
    | "/_private/_inventory-360/inventory/$inventoryId/lot/unassigned"
    | "/_private/_patient-360/patient/$patientId/create/address"
    | "/_private/_patient-360/patient/$patientId/create/patient-payor"
    | "/_private/_patient-360/patient/$patientId/create/payment"
    | "/_private/_admin/entity/$entityId/services/"
    | "/_private/_admin/entity/$entityId/visibility/"
    | "/_private/_admin/user/$userId/commissions/"
    | "/_private/_admin/user/$userId/entities/"
    | "/_private/_admin/user/$userId/permissions/"
    | "/_private/_patient-360/bundle/$bundleId/products/"
    | "/_private/_patient-360/order/$orderId/contents/"
    | "/_private/_practice-360/bulk-bundle/$bulkBundleId/products/"
    | "/_private/_practice-360/bulk-order/$bulkOrderId/contents/"
    | "/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/"
    | "/_private/_stock-360/stock-order/$stockOrderId/contents/"
    | "/_private/_warehouse-360/_analytics/warehouse360-analytics/monthly-historic/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren;
  PublicRouteRoute: typeof PublicRouteRouteWithChildren;
  AuthRouteRoute: typeof AuthRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/auth": {
      id: "/auth";
      path: "/auth";
      fullPath: "/auth";
      preLoaderRoute: typeof AuthRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_public": {
      id: "/_public";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PublicRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_private": {
      id: "/_private";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_private/": {
      id: "/_private/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof PrivateIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/auth/mfa-challenge": {
      id: "/auth/mfa-challenge";
      path: "/mfa-challenge";
      fullPath: "/auth/mfa-challenge";
      preLoaderRoute: typeof AuthMfaChallengeRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    "/auth/login": {
      id: "/auth/login";
      path: "/login";
      fullPath: "/auth/login";
      preLoaderRoute: typeof AuthLoginRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    "/auth/forgot-password": {
      id: "/auth/forgot-password";
      path: "/forgot-password";
      fullPath: "/auth/forgot-password";
      preLoaderRoute: typeof AuthForgotPasswordRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    "/auth/action": {
      id: "/auth/action";
      path: "/action";
      fullPath: "/auth/action";
      preLoaderRoute: typeof AuthActionRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    "/_public/terms-of-use": {
      id: "/_public/terms-of-use";
      path: "/terms-of-use";
      fullPath: "/terms-of-use";
      preLoaderRoute: typeof PublicTermsOfUseRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    "/_public/privacy-policy": {
      id: "/_public/privacy-policy";
      path: "/privacy-policy";
      fullPath: "/privacy-policy";
      preLoaderRoute: typeof PublicPrivacyPolicyRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    "/_public/mcp-login": {
      id: "/_public/mcp-login";
      path: "/mcp-login";
      fullPath: "/mcp-login";
      preLoaderRoute: typeof PublicMcpLoginRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    "/_private/release-notes": {
      id: "/_private/release-notes";
      path: "/release-notes";
      fullPath: "/release-notes";
      preLoaderRoute: typeof PrivateReleaseNotesRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/product": {
      id: "/_private/product";
      path: "/product";
      fullPath: "/product";
      preLoaderRoute: typeof PrivateProductRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/catalog-product": {
      id: "/_private/catalog-product";
      path: "/catalog-product";
      fullPath: "/catalog-product";
      preLoaderRoute: typeof PrivateCatalogProductRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_warehouse-360": {
      id: "/_private/_warehouse-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateWarehouse360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_stock-360": {
      id: "/_private/_stock-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateStock360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_sales-360": {
      id: "/_private/_sales-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateSales360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_practice-360": {
      id: "/_private/_practice-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivatePractice360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_pharmacy-360": {
      id: "/_private/_pharmacy-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivatePharmacy360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_patient-pharmcy-360": {
      id: "/_private/_patient-pharmcy-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivatePatientPharmcy360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_patient-360": {
      id: "/_private/_patient-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivatePatient360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_inventory-360": {
      id: "/_private/_inventory-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateInventory360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_fulfillment-360": {
      id: "/_private/_fulfillment-360";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateFulfillment360RouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_bulk-invoice": {
      id: "/_private/_bulk-invoice";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateBulkInvoiceRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_admin": {
      id: "/_private/_admin";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateAdminRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/profile/": {
      id: "/_private/profile/";
      path: "/profile";
      fullPath: "/profile/";
      preLoaderRoute: typeof PrivateProfileIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_public/patient-payment-link/$patientPaymentLinkId": {
      id: "/_public/patient-payment-link/$patientPaymentLinkId";
      path: "/patient-payment-link/$patientPaymentLinkId";
      fullPath: "/patient-payment-link/$patientPaymentLinkId";
      preLoaderRoute: typeof PublicPatientPaymentLinkPatientPaymentLinkIdRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    "/_public/instructions/$patientCampaignId": {
      id: "/_public/instructions/$patientCampaignId";
      path: "/instructions/$patientCampaignId";
      fullPath: "/instructions/$patientCampaignId";
      preLoaderRoute: typeof PublicInstructionsPatientCampaignIdRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    "/_private/task/lookup": {
      id: "/_private/task/lookup";
      path: "/task/lookup";
      fullPath: "/task/lookup";
      preLoaderRoute: typeof PrivateTaskLookupRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/product/brands": {
      id: "/_private/product/brands";
      path: "/brands";
      fullPath: "/product/brands";
      preLoaderRoute: typeof PrivateProductBrandsRouteImport;
      parentRoute: typeof PrivateProductRouteRoute;
    };
    "/_private/product/bases": {
      id: "/_private/product/bases";
      path: "/bases";
      fullPath: "/product/bases";
      preLoaderRoute: typeof PrivateProductBasesRouteImport;
      parentRoute: typeof PrivateProductRouteRoute;
    };
    "/_private/catalog-product/lookup": {
      id: "/_private/catalog-product/lookup";
      path: "/lookup";
      fullPath: "/catalog-product/lookup";
      preLoaderRoute: typeof PrivateCatalogProductLookupRouteImport;
      parentRoute: typeof PrivateCatalogProductRouteRoute;
    };
    "/_private/catalog-product/create": {
      id: "/_private/catalog-product/create";
      path: "/create";
      fullPath: "/catalog-product/create";
      preLoaderRoute: typeof PrivateCatalogProductCreateRouteImport;
      parentRoute: typeof PrivateCatalogProductRouteRoute;
    };
    "/_private/_warehouse-360/purchase-orders": {
      id: "/_private/_warehouse-360/purchase-orders";
      path: "/purchase-orders";
      fullPath: "/purchase-orders";
      preLoaderRoute: typeof PrivateWarehouse360PurchaseOrdersRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_patient-360/texting": {
      id: "/_private/_patient-360/texting";
      path: "/texting";
      fullPath: "/texting";
      preLoaderRoute: typeof PrivatePatient360TextingRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/dispensing-overview": {
      id: "/_private/_patient-360/dispensing-overview";
      path: "/dispensing-overview";
      fullPath: "/dispensing-overview";
      preLoaderRoute: typeof PrivatePatient360DispensingOverviewRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/calling": {
      id: "/_private/_patient-360/calling";
      path: "/calling";
      fullPath: "/calling";
      preLoaderRoute: typeof PrivatePatient360CallingRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_admin/jobs": {
      id: "/_private/_admin/jobs";
      path: "/jobs";
      fullPath: "/jobs";
      preLoaderRoute: typeof PrivateAdminJobsRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_warehouse-360/_analytics": {
      id: "/_private/_warehouse-360/_analytics";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateWarehouse360AnalyticsRouteRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_admin/user": {
      id: "/_private/_admin/user";
      path: "/user";
      fullPath: "/user";
      preLoaderRoute: typeof PrivateAdminUserRouteRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/product/treatments/": {
      id: "/_private/product/treatments/";
      path: "/treatments";
      fullPath: "/product/treatments/";
      preLoaderRoute: typeof PrivateProductTreatmentsIndexRouteImport;
      parentRoute: typeof PrivateProductRouteRoute;
    };
    "/_private/entity/$entityId/": {
      id: "/_private/entity/$entityId/";
      path: "/entity/$entityId";
      fullPath: "/entity/$entityId/";
      preLoaderRoute: typeof PrivateEntityEntityIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/catalog-product/$catalogProductId/": {
      id: "/_private/catalog-product/$catalogProductId/";
      path: "/$catalogProductId";
      fullPath: "/catalog-product/$catalogProductId/";
      preLoaderRoute: typeof PrivateCatalogProductCatalogProductIdIndexRouteImport;
      parentRoute: typeof PrivateCatalogProductRouteRoute;
    };
    "/_private/_pharmacy-360/pharmacy360-analytics/": {
      id: "/_private/_pharmacy-360/pharmacy360-analytics/";
      path: "/pharmacy360-analytics";
      fullPath: "/pharmacy360-analytics/";
      preLoaderRoute: typeof PrivatePharmacy360Pharmacy360AnalyticsIndexRouteImport;
      parentRoute: typeof PrivatePharmacy360RouteRoute;
    };
    "/_private/_patient-360/patient360-analytics/": {
      id: "/_private/_patient-360/patient360-analytics/";
      path: "/patient360-analytics";
      fullPath: "/patient360-analytics/";
      preLoaderRoute: typeof PrivatePatient360Patient360AnalyticsIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_fulfillment-360/fulfillment360-analytics/": {
      id: "/_private/_fulfillment-360/fulfillment360-analytics/";
      path: "/fulfillment360-analytics";
      fullPath: "/fulfillment360-analytics/";
      preLoaderRoute: typeof PrivateFulfillment360Fulfillment360AnalyticsIndexRouteImport;
      parentRoute: typeof PrivateFulfillment360RouteRoute;
    };
    "/_private/_admin/best-rx/": {
      id: "/_private/_admin/best-rx/";
      path: "/best-rx";
      fullPath: "/best-rx/";
      preLoaderRoute: typeof PrivateAdminBestRxIndexRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/ai-chat/": {
      id: "/_private/_admin/ai-chat/";
      path: "/ai-chat";
      fullPath: "/ai-chat/";
      preLoaderRoute: typeof PrivateAdminAiChatIndexRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/catalog-product/$catalogProductId/edit": {
      id: "/_private/catalog-product/$catalogProductId/edit";
      path: "/$catalogProductId/edit";
      fullPath: "/catalog-product/$catalogProductId/edit";
      preLoaderRoute: typeof PrivateCatalogProductCatalogProductIdEditRouteImport;
      parentRoute: typeof PrivateCatalogProductRouteRoute;
    };
    "/_private/_warehouse-360/warehouse/lookup": {
      id: "/_private/_warehouse-360/warehouse/lookup";
      path: "/warehouse/lookup";
      fullPath: "/warehouse/lookup";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseLookupRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/warehouse/create": {
      id: "/_private/_warehouse-360/warehouse/create";
      path: "/warehouse/create";
      fullPath: "/warehouse/create";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseCreateRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/warehouse-vendor/create": {
      id: "/_private/_warehouse-360/warehouse-vendor/create";
      path: "/warehouse-vendor/create";
      fullPath: "/warehouse-vendor/create";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseVendorCreateRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/vendor/lookup": {
      id: "/_private/_warehouse-360/vendor/lookup";
      path: "/vendor/lookup";
      fullPath: "/vendor/lookup";
      preLoaderRoute: typeof PrivateWarehouse360VendorLookupRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/vendor/create": {
      id: "/_private/_warehouse-360/vendor/create";
      path: "/vendor/create";
      fullPath: "/vendor/create";
      preLoaderRoute: typeof PrivateWarehouse360VendorCreateRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/batch/lookup": {
      id: "/_private/_warehouse-360/batch/lookup";
      path: "/batch/lookup";
      fullPath: "/batch/lookup";
      preLoaderRoute: typeof PrivateWarehouse360BatchLookupRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/batch/create": {
      id: "/_private/_warehouse-360/batch/create";
      path: "/batch/create";
      fullPath: "/batch/create";
      preLoaderRoute: typeof PrivateWarehouse360BatchCreateRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_stock-360/stock-order/lookup": {
      id: "/_private/_stock-360/stock-order/lookup";
      path: "/stock-order/lookup";
      fullPath: "/stock-order/lookup";
      preLoaderRoute: typeof PrivateStock360StockOrderLookupRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_stock-360/stock-order/create": {
      id: "/_private/_stock-360/stock-order/create";
      path: "/stock-order/create";
      fullPath: "/stock-order/create";
      preLoaderRoute: typeof PrivateStock360StockOrderCreateRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_stock-360/owned-stock/lookup": {
      id: "/_private/_stock-360/owned-stock/lookup";
      path: "/owned-stock/lookup";
      fullPath: "/owned-stock/lookup";
      preLoaderRoute: typeof PrivateStock360OwnedStockLookupRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_sales-360/commissions/lookup": {
      id: "/_private/_sales-360/commissions/lookup";
      path: "/commissions/lookup";
      fullPath: "/commissions/lookup";
      preLoaderRoute: typeof PrivateSales360CommissionsLookupRouteImport;
      parentRoute: typeof PrivateSales360RouteRoute;
    };
    "/_private/_practice-360/bulk-reorder/lookup": {
      id: "/_private/_practice-360/bulk-reorder/lookup";
      path: "/bulk-reorder/lookup";
      fullPath: "/bulk-reorder/lookup";
      preLoaderRoute: typeof PrivatePractice360BulkReorderLookupRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-product/lookup": {
      id: "/_private/_practice-360/bulk-product/lookup";
      path: "/bulk-product/lookup";
      fullPath: "/bulk-product/lookup";
      preLoaderRoute: typeof PrivatePractice360BulkProductLookupRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-product/create": {
      id: "/_private/_practice-360/bulk-product/create";
      path: "/bulk-product/create";
      fullPath: "/bulk-product/create";
      preLoaderRoute: typeof PrivatePractice360BulkProductCreateRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-order/lookup": {
      id: "/_private/_practice-360/bulk-order/lookup";
      path: "/bulk-order/lookup";
      fullPath: "/bulk-order/lookup";
      preLoaderRoute: typeof PrivatePractice360BulkOrderLookupRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-order/create": {
      id: "/_private/_practice-360/bulk-order/create";
      path: "/bulk-order/create";
      fullPath: "/bulk-order/create";
      preLoaderRoute: typeof PrivatePractice360BulkOrderCreateRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-bundle/lookup": {
      id: "/_private/_practice-360/bulk-bundle/lookup";
      path: "/bulk-bundle/lookup";
      fullPath: "/bulk-bundle/lookup";
      preLoaderRoute: typeof PrivatePractice360BulkBundleLookupRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-bundle/create": {
      id: "/_private/_practice-360/bulk-bundle/create";
      path: "/bulk-bundle/create";
      fullPath: "/bulk-bundle/create";
      preLoaderRoute: typeof PrivatePractice360BulkBundleCreateRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_pharmacy-360/suborder/lookup": {
      id: "/_private/_pharmacy-360/suborder/lookup";
      path: "/suborder/lookup";
      fullPath: "/suborder/lookup";
      preLoaderRoute: typeof PrivatePharmacy360SuborderLookupRouteImport;
      parentRoute: typeof PrivatePharmacy360RouteRoute;
    };
    "/_private/_patient-pharmcy-360/product/lookup": {
      id: "/_private/_patient-pharmcy-360/product/lookup";
      path: "/product/lookup";
      fullPath: "/product/lookup";
      preLoaderRoute: typeof PrivatePatientPharmcy360ProductLookupRouteImport;
      parentRoute: typeof PrivatePatientPharmcy360RouteRoute;
    };
    "/_private/_patient-pharmcy-360/product/create": {
      id: "/_private/_patient-pharmcy-360/product/create";
      path: "/product/create";
      fullPath: "/product/create";
      preLoaderRoute: typeof PrivatePatientPharmcy360ProductCreateRouteImport;
      parentRoute: typeof PrivatePatientPharmcy360RouteRoute;
    };
    "/_private/_patient-360/patient/lookup": {
      id: "/_private/_patient-360/patient/lookup";
      path: "/patient/lookup";
      fullPath: "/patient/lookup";
      preLoaderRoute: typeof PrivatePatient360PatientLookupRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/patient/create": {
      id: "/_private/_patient-360/patient/create";
      path: "/patient/create";
      fullPath: "/patient/create";
      preLoaderRoute: typeof PrivatePatient360PatientCreateRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/order/lookup": {
      id: "/_private/_patient-360/order/lookup";
      path: "/order/lookup";
      fullPath: "/order/lookup";
      preLoaderRoute: typeof PrivatePatient360OrderLookupRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/order/create": {
      id: "/_private/_patient-360/order/create";
      path: "/order/create";
      fullPath: "/order/create";
      preLoaderRoute: typeof PrivatePatient360OrderCreateRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/bundle/lookup": {
      id: "/_private/_patient-360/bundle/lookup";
      path: "/bundle/lookup";
      fullPath: "/bundle/lookup";
      preLoaderRoute: typeof PrivatePatient360BundleLookupRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/bundle/create": {
      id: "/_private/_patient-360/bundle/create";
      path: "/bundle/create";
      fullPath: "/bundle/create";
      preLoaderRoute: typeof PrivatePatient360BundleCreateRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_inventory-360/recall/create": {
      id: "/_private/_inventory-360/recall/create";
      path: "/recall/create";
      fullPath: "/recall/create";
      preLoaderRoute: typeof PrivateInventory360RecallCreateRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory/create": {
      id: "/_private/_inventory-360/inventory/create";
      path: "/inventory/create";
      fullPath: "/inventory/create";
      preLoaderRoute: typeof PrivateInventory360InventoryCreateRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory-batch-log/lookup": {
      id: "/_private/_inventory-360/inventory-batch-log/lookup";
      path: "/inventory-batch-log/lookup";
      fullPath: "/inventory-batch-log/lookup";
      preLoaderRoute: typeof PrivateInventory360InventoryBatchLogLookupRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_bulk-invoice/bulk-invoice/lookup": {
      id: "/_private/_bulk-invoice/bulk-invoice/lookup";
      path: "/bulk-invoice/lookup";
      fullPath: "/bulk-invoice/lookup";
      preLoaderRoute: typeof PrivateBulkInvoiceBulkInvoiceLookupRouteImport;
      parentRoute: typeof PrivateBulkInvoiceRouteRoute;
    };
    "/_private/_admin/user/lookup": {
      id: "/_private/_admin/user/lookup";
      path: "/lookup";
      fullPath: "/user/lookup";
      preLoaderRoute: typeof PrivateAdminUserLookupRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/user/create": {
      id: "/_private/_admin/user/create";
      path: "/create";
      fullPath: "/user/create";
      preLoaderRoute: typeof PrivateAdminUserCreateRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/payor/lookup": {
      id: "/_private/_admin/payor/lookup";
      path: "/payor/lookup";
      fullPath: "/payor/lookup";
      preLoaderRoute: typeof PrivateAdminPayorLookupRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/payor/create": {
      id: "/_private/_admin/payor/create";
      path: "/payor/create";
      fullPath: "/payor/create";
      preLoaderRoute: typeof PrivateAdminPayorCreateRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/entity/lookup": {
      id: "/_private/_admin/entity/lookup";
      path: "/entity/lookup";
      fullPath: "/entity/lookup";
      preLoaderRoute: typeof PrivateAdminEntityLookupRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/entity/create": {
      id: "/_private/_admin/entity/create";
      path: "/entity/create";
      fullPath: "/entity/create";
      preLoaderRoute: typeof PrivateAdminEntityCreateRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/catalog-product/$catalogProductId/components/": {
      id: "/_private/catalog-product/$catalogProductId/components/";
      path: "/$catalogProductId/components";
      fullPath: "/catalog-product/$catalogProductId/components/";
      preLoaderRoute: typeof PrivateCatalogProductCatalogProductIdComponentsIndexRouteImport;
      parentRoute: typeof PrivateCatalogProductRouteRoute;
    };
    "/_private/_warehouse-360/warehouse/$warehouseId/": {
      id: "/_private/_warehouse-360/warehouse/$warehouseId/";
      path: "/warehouse/$warehouseId";
      fullPath: "/warehouse/$warehouseId/";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseWarehouseIdIndexRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/vendor/$vendorId/": {
      id: "/_private/_warehouse-360/vendor/$vendorId/";
      path: "/vendor/$vendorId";
      fullPath: "/vendor/$vendorId/";
      preLoaderRoute: typeof PrivateWarehouse360VendorVendorIdIndexRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/batch/$batchId/": {
      id: "/_private/_warehouse-360/batch/$batchId/";
      path: "/batch/$batchId";
      fullPath: "/batch/$batchId/";
      preLoaderRoute: typeof PrivateWarehouse360BatchBatchIdIndexRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/_analytics/warehouse360-analytics/": {
      id: "/_private/_warehouse-360/_analytics/warehouse360-analytics/";
      path: "/warehouse360-analytics";
      fullPath: "/warehouse360-analytics/";
      preLoaderRoute: typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRouteImport;
      parentRoute: typeof PrivateWarehouse360AnalyticsRouteRoute;
    };
    "/_private/_stock-360/stock-order/$stockOrderId/": {
      id: "/_private/_stock-360/stock-order/$stockOrderId/";
      path: "/stock-order/$stockOrderId";
      fullPath: "/stock-order/$stockOrderId/";
      preLoaderRoute: typeof PrivateStock360StockOrderStockOrderIdIndexRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_stock-360/owned-stock/$catalogProductId/": {
      id: "/_private/_stock-360/owned-stock/$catalogProductId/";
      path: "/owned-stock/$catalogProductId";
      fullPath: "/owned-stock/$catalogProductId/";
      preLoaderRoute: typeof PrivateStock360OwnedStockCatalogProductIdIndexRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_practice-360/bulk-product/$bulkProductId/": {
      id: "/_private/_practice-360/bulk-product/$bulkProductId/";
      path: "/bulk-product/$bulkProductId";
      fullPath: "/bulk-product/$bulkProductId/";
      preLoaderRoute: typeof PrivatePractice360BulkProductBulkProductIdIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-order/$bulkOrderId/": {
      id: "/_private/_practice-360/bulk-order/$bulkOrderId/";
      path: "/bulk-order/$bulkOrderId";
      fullPath: "/bulk-order/$bulkOrderId/";
      preLoaderRoute: typeof PrivatePractice360BulkOrderBulkOrderIdIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-bundle/$bulkBundleId/": {
      id: "/_private/_practice-360/bulk-bundle/$bulkBundleId/";
      path: "/bulk-bundle/$bulkBundleId";
      fullPath: "/bulk-bundle/$bulkBundleId/";
      preLoaderRoute: typeof PrivatePractice360BulkBundleBulkBundleIdIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_pharmacy-360/suborder/$suborderId/": {
      id: "/_private/_pharmacy-360/suborder/$suborderId/";
      path: "/suborder/$suborderId";
      fullPath: "/suborder/$suborderId/";
      preLoaderRoute: typeof PrivatePharmacy360SuborderSuborderIdIndexRouteImport;
      parentRoute: typeof PrivatePharmacy360RouteRoute;
    };
    "/_private/_patient-pharmcy-360/product/$productId/": {
      id: "/_private/_patient-pharmcy-360/product/$productId/";
      path: "/product/$productId";
      fullPath: "/product/$productId/";
      preLoaderRoute: typeof PrivatePatientPharmcy360ProductProductIdIndexRouteImport;
      parentRoute: typeof PrivatePatientPharmcy360RouteRoute;
    };
    "/_private/_patient-360/patient/$patientId/": {
      id: "/_private/_patient-360/patient/$patientId/";
      path: "/patient/$patientId";
      fullPath: "/patient/$patientId/";
      preLoaderRoute: typeof PrivatePatient360PatientPatientIdIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/order/$orderId/": {
      id: "/_private/_patient-360/order/$orderId/";
      path: "/order/$orderId";
      fullPath: "/order/$orderId/";
      preLoaderRoute: typeof PrivatePatient360OrderOrderIdIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/bundle/$bundleId/": {
      id: "/_private/_patient-360/bundle/$bundleId/";
      path: "/bundle/$bundleId";
      fullPath: "/bundle/$bundleId/";
      preLoaderRoute: typeof PrivatePatient360BundleBundleIdIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_inventory-360/recall/lookup/": {
      id: "/_private/_inventory-360/recall/lookup/";
      path: "/recall/lookup";
      fullPath: "/recall/lookup/";
      preLoaderRoute: typeof PrivateInventory360RecallLookupIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/recall/$recallEventId/": {
      id: "/_private/_inventory-360/recall/$recallEventId/";
      path: "/recall/$recallEventId";
      fullPath: "/recall/$recallEventId/";
      preLoaderRoute: typeof PrivateInventory360RecallRecallEventIdIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory/lookup/": {
      id: "/_private/_inventory-360/inventory/lookup/";
      path: "/inventory/lookup";
      fullPath: "/inventory/lookup/";
      preLoaderRoute: typeof PrivateInventory360InventoryLookupIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory/$inventoryId/": {
      id: "/_private/_inventory-360/inventory/$inventoryId/";
      path: "/inventory/$inventoryId";
      fullPath: "/inventory/$inventoryId/";
      preLoaderRoute: typeof PrivateInventory360InventoryInventoryIdIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory-vendor/lookup/": {
      id: "/_private/_inventory-360/inventory-vendor/lookup/";
      path: "/inventory-vendor/lookup";
      fullPath: "/inventory-vendor/lookup/";
      preLoaderRoute: typeof PrivateInventory360InventoryVendorLookupIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory-lot/lookup/": {
      id: "/_private/_inventory-360/inventory-lot/lookup/";
      path: "/inventory-lot/lookup";
      fullPath: "/inventory-lot/lookup/";
      preLoaderRoute: typeof PrivateInventory360InventoryLotLookupIndexRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_fulfillment-360/bulk-suborder/lookup/": {
      id: "/_private/_fulfillment-360/bulk-suborder/lookup/";
      path: "/bulk-suborder/lookup";
      fullPath: "/bulk-suborder/lookup/";
      preLoaderRoute: typeof PrivateFulfillment360BulkSuborderLookupIndexRouteImport;
      parentRoute: typeof PrivateFulfillment360RouteRoute;
    };
    "/_private/_fulfillment-360/bulk-suborder/$bulkSuborderId/": {
      id: "/_private/_fulfillment-360/bulk-suborder/$bulkSuborderId/";
      path: "/bulk-suborder/$bulkSuborderId";
      fullPath: "/bulk-suborder/$bulkSuborderId/";
      preLoaderRoute: typeof PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRouteImport;
      parentRoute: typeof PrivateFulfillment360RouteRoute;
    };
    "/_private/_bulk-invoice/bulk-invoice/$bulkInvoiceId/": {
      id: "/_private/_bulk-invoice/bulk-invoice/$bulkInvoiceId/";
      path: "/bulk-invoice/$bulkInvoiceId";
      fullPath: "/bulk-invoice/$bulkInvoiceId/";
      preLoaderRoute: typeof PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRouteImport;
      parentRoute: typeof PrivateBulkInvoiceRouteRoute;
    };
    "/_private/_admin/user/$userId/": {
      id: "/_private/_admin/user/$userId/";
      path: "/$userId";
      fullPath: "/user/$userId/";
      preLoaderRoute: typeof PrivateAdminUserUserIdIndexRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/payor/$payorId/": {
      id: "/_private/_admin/payor/$payorId/";
      path: "/payor/$payorId";
      fullPath: "/payor/$payorId/";
      preLoaderRoute: typeof PrivateAdminPayorPayorIdIndexRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_warehouse-360/warehouse/$warehouseId/edit": {
      id: "/_private/_warehouse-360/warehouse/$warehouseId/edit";
      path: "/warehouse/$warehouseId/edit";
      fullPath: "/warehouse/$warehouseId/edit";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseWarehouseIdEditRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit": {
      id: "/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit";
      path: "/warehouse-vendor/$warehouseVendorId/edit";
      fullPath: "/warehouse-vendor/$warehouseVendorId/edit";
      preLoaderRoute: typeof PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/vendor/$vendorId/edit": {
      id: "/_private/_warehouse-360/vendor/$vendorId/edit";
      path: "/vendor/$vendorId/edit";
      fullPath: "/vendor/$vendorId/edit";
      preLoaderRoute: typeof PrivateWarehouse360VendorVendorIdEditRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_warehouse-360/batch/$batchId/edit": {
      id: "/_private/_warehouse-360/batch/$batchId/edit";
      path: "/batch/$batchId/edit";
      fullPath: "/batch/$batchId/edit";
      preLoaderRoute: typeof PrivateWarehouse360BatchBatchIdEditRouteImport;
      parentRoute: typeof PrivateWarehouse360RouteRoute;
    };
    "/_private/_stock-360/stock-order/$stockOrderId/edit": {
      id: "/_private/_stock-360/stock-order/$stockOrderId/edit";
      path: "/stock-order/$stockOrderId/edit";
      fullPath: "/stock-order/$stockOrderId/edit";
      preLoaderRoute: typeof PrivateStock360StockOrderStockOrderIdEditRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_practice-360/bulk-product/$bulkProductId/edit": {
      id: "/_private/_practice-360/bulk-product/$bulkProductId/edit";
      path: "/bulk-product/$bulkProductId/edit";
      fullPath: "/bulk-product/$bulkProductId/edit";
      preLoaderRoute: typeof PrivatePractice360BulkProductBulkProductIdEditRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-order/$bulkOrderId/edit": {
      id: "/_private/_practice-360/bulk-order/$bulkOrderId/edit";
      path: "/bulk-order/$bulkOrderId/edit";
      fullPath: "/bulk-order/$bulkOrderId/edit";
      preLoaderRoute: typeof PrivatePractice360BulkOrderBulkOrderIdEditRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-bundle/$bulkBundleId/edit": {
      id: "/_private/_practice-360/bulk-bundle/$bulkBundleId/edit";
      path: "/bulk-bundle/$bulkBundleId/edit";
      fullPath: "/bulk-bundle/$bulkBundleId/edit";
      preLoaderRoute: typeof PrivatePractice360BulkBundleBulkBundleIdEditRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_patient-pharmcy-360/product/$productId/edit": {
      id: "/_private/_patient-pharmcy-360/product/$productId/edit";
      path: "/product/$productId/edit";
      fullPath: "/product/$productId/edit";
      preLoaderRoute: typeof PrivatePatientPharmcy360ProductProductIdEditRouteImport;
      parentRoute: typeof PrivatePatientPharmcy360RouteRoute;
    };
    "/_private/_patient-360/order/$orderId/edit": {
      id: "/_private/_patient-360/order/$orderId/edit";
      path: "/order/$orderId/edit";
      fullPath: "/order/$orderId/edit";
      preLoaderRoute: typeof PrivatePatient360OrderOrderIdEditRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/bundle/$bundleId/edit": {
      id: "/_private/_patient-360/bundle/$bundleId/edit";
      path: "/bundle/$bundleId/edit";
      fullPath: "/bundle/$bundleId/edit";
      preLoaderRoute: typeof PrivatePatient360BundleBundleIdEditRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_inventory-360/inventory/$inventoryId/edit": {
      id: "/_private/_inventory-360/inventory/$inventoryId/edit";
      path: "/inventory/$inventoryId/edit";
      fullPath: "/inventory/$inventoryId/edit";
      preLoaderRoute: typeof PrivateInventory360InventoryInventoryIdEditRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_admin/user/$userId/edit": {
      id: "/_private/_admin/user/$userId/edit";
      path: "/$userId/edit";
      fullPath: "/user/$userId/edit";
      preLoaderRoute: typeof PrivateAdminUserUserIdEditRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/payor/$payorId/edit": {
      id: "/_private/_admin/payor/$payorId/edit";
      path: "/payor/$payorId/edit";
      fullPath: "/payor/$payorId/edit";
      preLoaderRoute: typeof PrivateAdminPayorPayorIdEditRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/entity/$entityId/edit": {
      id: "/_private/_admin/entity/$entityId/edit";
      path: "/entity/$entityId/edit";
      fullPath: "/entity/$entityId/edit";
      preLoaderRoute: typeof PrivateAdminEntityEntityIdEditRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_warehouse-360/_analytics/warehouse360-analytics/monthly-historic/": {
      id: "/_private/_warehouse-360/_analytics/warehouse360-analytics/monthly-historic/";
      path: "/warehouse360-analytics/monthly-historic";
      fullPath: "/warehouse360-analytics/monthly-historic/";
      preLoaderRoute: typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRouteImport;
      parentRoute: typeof PrivateWarehouse360AnalyticsRouteRoute;
    };
    "/_private/_stock-360/stock-order/$stockOrderId/contents/": {
      id: "/_private/_stock-360/stock-order/$stockOrderId/contents/";
      path: "/stock-order/$stockOrderId/contents";
      fullPath: "/stock-order/$stockOrderId/contents/";
      preLoaderRoute: typeof PrivateStock360StockOrderStockOrderIdContentsIndexRouteImport;
      parentRoute: typeof PrivateStock360RouteRoute;
    };
    "/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/": {
      id: "/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/";
      path: "/bulk-reorder/$bulkOrderId/schedule";
      fullPath: "/bulk-reorder/$bulkOrderId/schedule/";
      preLoaderRoute: typeof PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-order/$bulkOrderId/contents/": {
      id: "/_private/_practice-360/bulk-order/$bulkOrderId/contents/";
      path: "/bulk-order/$bulkOrderId/contents";
      fullPath: "/bulk-order/$bulkOrderId/contents/";
      preLoaderRoute: typeof PrivatePractice360BulkOrderBulkOrderIdContentsIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_practice-360/bulk-bundle/$bulkBundleId/products/": {
      id: "/_private/_practice-360/bulk-bundle/$bulkBundleId/products/";
      path: "/bulk-bundle/$bulkBundleId/products";
      fullPath: "/bulk-bundle/$bulkBundleId/products/";
      preLoaderRoute: typeof PrivatePractice360BulkBundleBulkBundleIdProductsIndexRouteImport;
      parentRoute: typeof PrivatePractice360RouteRoute;
    };
    "/_private/_patient-360/order/$orderId/contents/": {
      id: "/_private/_patient-360/order/$orderId/contents/";
      path: "/order/$orderId/contents";
      fullPath: "/order/$orderId/contents/";
      preLoaderRoute: typeof PrivatePatient360OrderOrderIdContentsIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/bundle/$bundleId/products/": {
      id: "/_private/_patient-360/bundle/$bundleId/products/";
      path: "/bundle/$bundleId/products";
      fullPath: "/bundle/$bundleId/products/";
      preLoaderRoute: typeof PrivatePatient360BundleBundleIdProductsIndexRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_admin/user/$userId/permissions/": {
      id: "/_private/_admin/user/$userId/permissions/";
      path: "/$userId/permissions";
      fullPath: "/user/$userId/permissions/";
      preLoaderRoute: typeof PrivateAdminUserUserIdPermissionsIndexRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/user/$userId/entities/": {
      id: "/_private/_admin/user/$userId/entities/";
      path: "/$userId/entities";
      fullPath: "/user/$userId/entities/";
      preLoaderRoute: typeof PrivateAdminUserUserIdEntitiesIndexRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/user/$userId/commissions/": {
      id: "/_private/_admin/user/$userId/commissions/";
      path: "/$userId/commissions";
      fullPath: "/user/$userId/commissions/";
      preLoaderRoute: typeof PrivateAdminUserUserIdCommissionsIndexRouteImport;
      parentRoute: typeof PrivateAdminUserRouteRoute;
    };
    "/_private/_admin/entity/$entityId/visibility/": {
      id: "/_private/_admin/entity/$entityId/visibility/";
      path: "/entity/$entityId/visibility";
      fullPath: "/entity/$entityId/visibility/";
      preLoaderRoute: typeof PrivateAdminEntityEntityIdVisibilityIndexRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_admin/entity/$entityId/services/": {
      id: "/_private/_admin/entity/$entityId/services/";
      path: "/entity/$entityId/services";
      fullPath: "/entity/$entityId/services/";
      preLoaderRoute: typeof PrivateAdminEntityEntityIdServicesIndexRouteImport;
      parentRoute: typeof PrivateAdminRouteRoute;
    };
    "/_private/_patient-360/patient/$patientId/create/payment": {
      id: "/_private/_patient-360/patient/$patientId/create/payment";
      path: "/patient/$patientId/create/payment";
      fullPath: "/patient/$patientId/create/payment";
      preLoaderRoute: typeof PrivatePatient360PatientPatientIdCreatePaymentRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/patient/$patientId/create/patient-payor": {
      id: "/_private/_patient-360/patient/$patientId/create/patient-payor";
      path: "/patient/$patientId/create/patient-payor";
      fullPath: "/patient/$patientId/create/patient-payor";
      preLoaderRoute: typeof PrivatePatient360PatientPatientIdCreatePatientPayorRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_patient-360/patient/$patientId/create/address": {
      id: "/_private/_patient-360/patient/$patientId/create/address";
      path: "/patient/$patientId/create/address";
      fullPath: "/patient/$patientId/create/address";
      preLoaderRoute: typeof PrivatePatient360PatientPatientIdCreateAddressRouteImport;
      parentRoute: typeof PrivatePatient360RouteRoute;
    };
    "/_private/_inventory-360/inventory/$inventoryId/lot/unassigned": {
      id: "/_private/_inventory-360/inventory/$inventoryId/lot/unassigned";
      path: "/inventory/$inventoryId/lot/unassigned";
      fullPath: "/inventory/$inventoryId/lot/unassigned";
      preLoaderRoute: typeof PrivateInventory360InventoryInventoryIdLotUnassignedRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
    "/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber": {
      id: "/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber";
      path: "/inventory/$inventoryId/lot/$lotNumber";
      fullPath: "/inventory/$inventoryId/lot/$lotNumber";
      preLoaderRoute: typeof PrivateInventory360InventoryInventoryIdLotLotNumberRouteImport;
      parentRoute: typeof PrivateInventory360RouteRoute;
    };
  }
}

interface PrivateAdminUserRouteRouteChildren {
  PrivateAdminUserCreateRoute: typeof PrivateAdminUserCreateRoute;
  PrivateAdminUserLookupRoute: typeof PrivateAdminUserLookupRoute;
  PrivateAdminUserUserIdEditRoute: typeof PrivateAdminUserUserIdEditRoute;
  PrivateAdminUserUserIdIndexRoute: typeof PrivateAdminUserUserIdIndexRoute;
  PrivateAdminUserUserIdCommissionsIndexRoute: typeof PrivateAdminUserUserIdCommissionsIndexRoute;
  PrivateAdminUserUserIdEntitiesIndexRoute: typeof PrivateAdminUserUserIdEntitiesIndexRoute;
  PrivateAdminUserUserIdPermissionsIndexRoute: typeof PrivateAdminUserUserIdPermissionsIndexRoute;
}

const PrivateAdminUserRouteRouteChildren: PrivateAdminUserRouteRouteChildren = {
  PrivateAdminUserCreateRoute: PrivateAdminUserCreateRoute,
  PrivateAdminUserLookupRoute: PrivateAdminUserLookupRoute,
  PrivateAdminUserUserIdEditRoute: PrivateAdminUserUserIdEditRoute,
  PrivateAdminUserUserIdIndexRoute: PrivateAdminUserUserIdIndexRoute,
  PrivateAdminUserUserIdCommissionsIndexRoute:
    PrivateAdminUserUserIdCommissionsIndexRoute,
  PrivateAdminUserUserIdEntitiesIndexRoute:
    PrivateAdminUserUserIdEntitiesIndexRoute,
  PrivateAdminUserUserIdPermissionsIndexRoute:
    PrivateAdminUserUserIdPermissionsIndexRoute,
};

const PrivateAdminUserRouteRouteWithChildren =
  PrivateAdminUserRouteRoute._addFileChildren(
    PrivateAdminUserRouteRouteChildren,
  );

interface PrivateAdminRouteRouteChildren {
  PrivateAdminUserRouteRoute: typeof PrivateAdminUserRouteRouteWithChildren;
  PrivateAdminJobsRoute: typeof PrivateAdminJobsRoute;
  PrivateAdminEntityCreateRoute: typeof PrivateAdminEntityCreateRoute;
  PrivateAdminEntityLookupRoute: typeof PrivateAdminEntityLookupRoute;
  PrivateAdminPayorCreateRoute: typeof PrivateAdminPayorCreateRoute;
  PrivateAdminPayorLookupRoute: typeof PrivateAdminPayorLookupRoute;
  PrivateAdminAiChatIndexRoute: typeof PrivateAdminAiChatIndexRoute;
  PrivateAdminBestRxIndexRoute: typeof PrivateAdminBestRxIndexRoute;
  PrivateAdminEntityEntityIdEditRoute: typeof PrivateAdminEntityEntityIdEditRoute;
  PrivateAdminPayorPayorIdEditRoute: typeof PrivateAdminPayorPayorIdEditRoute;
  PrivateAdminPayorPayorIdIndexRoute: typeof PrivateAdminPayorPayorIdIndexRoute;
  PrivateAdminEntityEntityIdServicesIndexRoute: typeof PrivateAdminEntityEntityIdServicesIndexRoute;
  PrivateAdminEntityEntityIdVisibilityIndexRoute: typeof PrivateAdminEntityEntityIdVisibilityIndexRoute;
}

const PrivateAdminRouteRouteChildren: PrivateAdminRouteRouteChildren = {
  PrivateAdminUserRouteRoute: PrivateAdminUserRouteRouteWithChildren,
  PrivateAdminJobsRoute: PrivateAdminJobsRoute,
  PrivateAdminEntityCreateRoute: PrivateAdminEntityCreateRoute,
  PrivateAdminEntityLookupRoute: PrivateAdminEntityLookupRoute,
  PrivateAdminPayorCreateRoute: PrivateAdminPayorCreateRoute,
  PrivateAdminPayorLookupRoute: PrivateAdminPayorLookupRoute,
  PrivateAdminAiChatIndexRoute: PrivateAdminAiChatIndexRoute,
  PrivateAdminBestRxIndexRoute: PrivateAdminBestRxIndexRoute,
  PrivateAdminEntityEntityIdEditRoute: PrivateAdminEntityEntityIdEditRoute,
  PrivateAdminPayorPayorIdEditRoute: PrivateAdminPayorPayorIdEditRoute,
  PrivateAdminPayorPayorIdIndexRoute: PrivateAdminPayorPayorIdIndexRoute,
  PrivateAdminEntityEntityIdServicesIndexRoute:
    PrivateAdminEntityEntityIdServicesIndexRoute,
  PrivateAdminEntityEntityIdVisibilityIndexRoute:
    PrivateAdminEntityEntityIdVisibilityIndexRoute,
};

const PrivateAdminRouteRouteWithChildren =
  PrivateAdminRouteRoute._addFileChildren(PrivateAdminRouteRouteChildren);

interface PrivateBulkInvoiceRouteRouteChildren {
  PrivateBulkInvoiceBulkInvoiceLookupRoute: typeof PrivateBulkInvoiceBulkInvoiceLookupRoute;
  PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute: typeof PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute;
}

const PrivateBulkInvoiceRouteRouteChildren: PrivateBulkInvoiceRouteRouteChildren =
  {
    PrivateBulkInvoiceBulkInvoiceLookupRoute:
      PrivateBulkInvoiceBulkInvoiceLookupRoute,
    PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute:
      PrivateBulkInvoiceBulkInvoiceBulkInvoiceIdIndexRoute,
  };

const PrivateBulkInvoiceRouteRouteWithChildren =
  PrivateBulkInvoiceRouteRoute._addFileChildren(
    PrivateBulkInvoiceRouteRouteChildren,
  );

interface PrivateFulfillment360RouteRouteChildren {
  PrivateFulfillment360Fulfillment360AnalyticsIndexRoute: typeof PrivateFulfillment360Fulfillment360AnalyticsIndexRoute;
  PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute: typeof PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute;
  PrivateFulfillment360BulkSuborderLookupIndexRoute: typeof PrivateFulfillment360BulkSuborderLookupIndexRoute;
}

const PrivateFulfillment360RouteRouteChildren: PrivateFulfillment360RouteRouteChildren =
  {
    PrivateFulfillment360Fulfillment360AnalyticsIndexRoute:
      PrivateFulfillment360Fulfillment360AnalyticsIndexRoute,
    PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute:
      PrivateFulfillment360BulkSuborderBulkSuborderIdIndexRoute,
    PrivateFulfillment360BulkSuborderLookupIndexRoute:
      PrivateFulfillment360BulkSuborderLookupIndexRoute,
  };

const PrivateFulfillment360RouteRouteWithChildren =
  PrivateFulfillment360RouteRoute._addFileChildren(
    PrivateFulfillment360RouteRouteChildren,
  );

interface PrivateInventory360RouteRouteChildren {
  PrivateInventory360InventoryBatchLogLookupRoute: typeof PrivateInventory360InventoryBatchLogLookupRoute;
  PrivateInventory360InventoryCreateRoute: typeof PrivateInventory360InventoryCreateRoute;
  PrivateInventory360RecallCreateRoute: typeof PrivateInventory360RecallCreateRoute;
  PrivateInventory360InventoryInventoryIdEditRoute: typeof PrivateInventory360InventoryInventoryIdEditRoute;
  PrivateInventory360InventoryLotLookupIndexRoute: typeof PrivateInventory360InventoryLotLookupIndexRoute;
  PrivateInventory360InventoryVendorLookupIndexRoute: typeof PrivateInventory360InventoryVendorLookupIndexRoute;
  PrivateInventory360InventoryInventoryIdIndexRoute: typeof PrivateInventory360InventoryInventoryIdIndexRoute;
  PrivateInventory360InventoryLookupIndexRoute: typeof PrivateInventory360InventoryLookupIndexRoute;
  PrivateInventory360RecallRecallEventIdIndexRoute: typeof PrivateInventory360RecallRecallEventIdIndexRoute;
  PrivateInventory360RecallLookupIndexRoute: typeof PrivateInventory360RecallLookupIndexRoute;
  PrivateInventory360InventoryInventoryIdLotLotNumberRoute: typeof PrivateInventory360InventoryInventoryIdLotLotNumberRoute;
  PrivateInventory360InventoryInventoryIdLotUnassignedRoute: typeof PrivateInventory360InventoryInventoryIdLotUnassignedRoute;
}

const PrivateInventory360RouteRouteChildren: PrivateInventory360RouteRouteChildren =
  {
    PrivateInventory360InventoryBatchLogLookupRoute:
      PrivateInventory360InventoryBatchLogLookupRoute,
    PrivateInventory360InventoryCreateRoute:
      PrivateInventory360InventoryCreateRoute,
    PrivateInventory360RecallCreateRoute: PrivateInventory360RecallCreateRoute,
    PrivateInventory360InventoryInventoryIdEditRoute:
      PrivateInventory360InventoryInventoryIdEditRoute,
    PrivateInventory360InventoryLotLookupIndexRoute:
      PrivateInventory360InventoryLotLookupIndexRoute,
    PrivateInventory360InventoryVendorLookupIndexRoute:
      PrivateInventory360InventoryVendorLookupIndexRoute,
    PrivateInventory360InventoryInventoryIdIndexRoute:
      PrivateInventory360InventoryInventoryIdIndexRoute,
    PrivateInventory360InventoryLookupIndexRoute:
      PrivateInventory360InventoryLookupIndexRoute,
    PrivateInventory360RecallRecallEventIdIndexRoute:
      PrivateInventory360RecallRecallEventIdIndexRoute,
    PrivateInventory360RecallLookupIndexRoute:
      PrivateInventory360RecallLookupIndexRoute,
    PrivateInventory360InventoryInventoryIdLotLotNumberRoute:
      PrivateInventory360InventoryInventoryIdLotLotNumberRoute,
    PrivateInventory360InventoryInventoryIdLotUnassignedRoute:
      PrivateInventory360InventoryInventoryIdLotUnassignedRoute,
  };

const PrivateInventory360RouteRouteWithChildren =
  PrivateInventory360RouteRoute._addFileChildren(
    PrivateInventory360RouteRouteChildren,
  );

interface PrivatePatient360RouteRouteChildren {
  PrivatePatient360CallingRoute: typeof PrivatePatient360CallingRoute;
  PrivatePatient360DispensingOverviewRoute: typeof PrivatePatient360DispensingOverviewRoute;
  PrivatePatient360TextingRoute: typeof PrivatePatient360TextingRoute;
  PrivatePatient360BundleCreateRoute: typeof PrivatePatient360BundleCreateRoute;
  PrivatePatient360BundleLookupRoute: typeof PrivatePatient360BundleLookupRoute;
  PrivatePatient360OrderCreateRoute: typeof PrivatePatient360OrderCreateRoute;
  PrivatePatient360OrderLookupRoute: typeof PrivatePatient360OrderLookupRoute;
  PrivatePatient360PatientCreateRoute: typeof PrivatePatient360PatientCreateRoute;
  PrivatePatient360PatientLookupRoute: typeof PrivatePatient360PatientLookupRoute;
  PrivatePatient360Patient360AnalyticsIndexRoute: typeof PrivatePatient360Patient360AnalyticsIndexRoute;
  PrivatePatient360BundleBundleIdEditRoute: typeof PrivatePatient360BundleBundleIdEditRoute;
  PrivatePatient360OrderOrderIdEditRoute: typeof PrivatePatient360OrderOrderIdEditRoute;
  PrivatePatient360BundleBundleIdIndexRoute: typeof PrivatePatient360BundleBundleIdIndexRoute;
  PrivatePatient360OrderOrderIdIndexRoute: typeof PrivatePatient360OrderOrderIdIndexRoute;
  PrivatePatient360PatientPatientIdIndexRoute: typeof PrivatePatient360PatientPatientIdIndexRoute;
  PrivatePatient360PatientPatientIdCreateAddressRoute: typeof PrivatePatient360PatientPatientIdCreateAddressRoute;
  PrivatePatient360PatientPatientIdCreatePatientPayorRoute: typeof PrivatePatient360PatientPatientIdCreatePatientPayorRoute;
  PrivatePatient360PatientPatientIdCreatePaymentRoute: typeof PrivatePatient360PatientPatientIdCreatePaymentRoute;
  PrivatePatient360BundleBundleIdProductsIndexRoute: typeof PrivatePatient360BundleBundleIdProductsIndexRoute;
  PrivatePatient360OrderOrderIdContentsIndexRoute: typeof PrivatePatient360OrderOrderIdContentsIndexRoute;
}

const PrivatePatient360RouteRouteChildren: PrivatePatient360RouteRouteChildren =
  {
    PrivatePatient360CallingRoute: PrivatePatient360CallingRoute,
    PrivatePatient360DispensingOverviewRoute:
      PrivatePatient360DispensingOverviewRoute,
    PrivatePatient360TextingRoute: PrivatePatient360TextingRoute,
    PrivatePatient360BundleCreateRoute: PrivatePatient360BundleCreateRoute,
    PrivatePatient360BundleLookupRoute: PrivatePatient360BundleLookupRoute,
    PrivatePatient360OrderCreateRoute: PrivatePatient360OrderCreateRoute,
    PrivatePatient360OrderLookupRoute: PrivatePatient360OrderLookupRoute,
    PrivatePatient360PatientCreateRoute: PrivatePatient360PatientCreateRoute,
    PrivatePatient360PatientLookupRoute: PrivatePatient360PatientLookupRoute,
    PrivatePatient360Patient360AnalyticsIndexRoute:
      PrivatePatient360Patient360AnalyticsIndexRoute,
    PrivatePatient360BundleBundleIdEditRoute:
      PrivatePatient360BundleBundleIdEditRoute,
    PrivatePatient360OrderOrderIdEditRoute:
      PrivatePatient360OrderOrderIdEditRoute,
    PrivatePatient360BundleBundleIdIndexRoute:
      PrivatePatient360BundleBundleIdIndexRoute,
    PrivatePatient360OrderOrderIdIndexRoute:
      PrivatePatient360OrderOrderIdIndexRoute,
    PrivatePatient360PatientPatientIdIndexRoute:
      PrivatePatient360PatientPatientIdIndexRoute,
    PrivatePatient360PatientPatientIdCreateAddressRoute:
      PrivatePatient360PatientPatientIdCreateAddressRoute,
    PrivatePatient360PatientPatientIdCreatePatientPayorRoute:
      PrivatePatient360PatientPatientIdCreatePatientPayorRoute,
    PrivatePatient360PatientPatientIdCreatePaymentRoute:
      PrivatePatient360PatientPatientIdCreatePaymentRoute,
    PrivatePatient360BundleBundleIdProductsIndexRoute:
      PrivatePatient360BundleBundleIdProductsIndexRoute,
    PrivatePatient360OrderOrderIdContentsIndexRoute:
      PrivatePatient360OrderOrderIdContentsIndexRoute,
  };

const PrivatePatient360RouteRouteWithChildren =
  PrivatePatient360RouteRoute._addFileChildren(
    PrivatePatient360RouteRouteChildren,
  );

interface PrivatePatientPharmcy360RouteRouteChildren {
  PrivatePatientPharmcy360ProductCreateRoute: typeof PrivatePatientPharmcy360ProductCreateRoute;
  PrivatePatientPharmcy360ProductLookupRoute: typeof PrivatePatientPharmcy360ProductLookupRoute;
  PrivatePatientPharmcy360ProductProductIdEditRoute: typeof PrivatePatientPharmcy360ProductProductIdEditRoute;
  PrivatePatientPharmcy360ProductProductIdIndexRoute: typeof PrivatePatientPharmcy360ProductProductIdIndexRoute;
}

const PrivatePatientPharmcy360RouteRouteChildren: PrivatePatientPharmcy360RouteRouteChildren =
  {
    PrivatePatientPharmcy360ProductCreateRoute:
      PrivatePatientPharmcy360ProductCreateRoute,
    PrivatePatientPharmcy360ProductLookupRoute:
      PrivatePatientPharmcy360ProductLookupRoute,
    PrivatePatientPharmcy360ProductProductIdEditRoute:
      PrivatePatientPharmcy360ProductProductIdEditRoute,
    PrivatePatientPharmcy360ProductProductIdIndexRoute:
      PrivatePatientPharmcy360ProductProductIdIndexRoute,
  };

const PrivatePatientPharmcy360RouteRouteWithChildren =
  PrivatePatientPharmcy360RouteRoute._addFileChildren(
    PrivatePatientPharmcy360RouteRouteChildren,
  );

interface PrivatePharmacy360RouteRouteChildren {
  PrivatePharmacy360SuborderLookupRoute: typeof PrivatePharmacy360SuborderLookupRoute;
  PrivatePharmacy360Pharmacy360AnalyticsIndexRoute: typeof PrivatePharmacy360Pharmacy360AnalyticsIndexRoute;
  PrivatePharmacy360SuborderSuborderIdIndexRoute: typeof PrivatePharmacy360SuborderSuborderIdIndexRoute;
}

const PrivatePharmacy360RouteRouteChildren: PrivatePharmacy360RouteRouteChildren =
  {
    PrivatePharmacy360SuborderLookupRoute:
      PrivatePharmacy360SuborderLookupRoute,
    PrivatePharmacy360Pharmacy360AnalyticsIndexRoute:
      PrivatePharmacy360Pharmacy360AnalyticsIndexRoute,
    PrivatePharmacy360SuborderSuborderIdIndexRoute:
      PrivatePharmacy360SuborderSuborderIdIndexRoute,
  };

const PrivatePharmacy360RouteRouteWithChildren =
  PrivatePharmacy360RouteRoute._addFileChildren(
    PrivatePharmacy360RouteRouteChildren,
  );

interface PrivatePractice360RouteRouteChildren {
  PrivatePractice360BulkBundleCreateRoute: typeof PrivatePractice360BulkBundleCreateRoute;
  PrivatePractice360BulkBundleLookupRoute: typeof PrivatePractice360BulkBundleLookupRoute;
  PrivatePractice360BulkOrderCreateRoute: typeof PrivatePractice360BulkOrderCreateRoute;
  PrivatePractice360BulkOrderLookupRoute: typeof PrivatePractice360BulkOrderLookupRoute;
  PrivatePractice360BulkProductCreateRoute: typeof PrivatePractice360BulkProductCreateRoute;
  PrivatePractice360BulkProductLookupRoute: typeof PrivatePractice360BulkProductLookupRoute;
  PrivatePractice360BulkReorderLookupRoute: typeof PrivatePractice360BulkReorderLookupRoute;
  PrivatePractice360BulkBundleBulkBundleIdEditRoute: typeof PrivatePractice360BulkBundleBulkBundleIdEditRoute;
  PrivatePractice360BulkOrderBulkOrderIdEditRoute: typeof PrivatePractice360BulkOrderBulkOrderIdEditRoute;
  PrivatePractice360BulkProductBulkProductIdEditRoute: typeof PrivatePractice360BulkProductBulkProductIdEditRoute;
  PrivatePractice360BulkBundleBulkBundleIdIndexRoute: typeof PrivatePractice360BulkBundleBulkBundleIdIndexRoute;
  PrivatePractice360BulkOrderBulkOrderIdIndexRoute: typeof PrivatePractice360BulkOrderBulkOrderIdIndexRoute;
  PrivatePractice360BulkProductBulkProductIdIndexRoute: typeof PrivatePractice360BulkProductBulkProductIdIndexRoute;
  PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute: typeof PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute;
  PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute: typeof PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute;
  PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute: typeof PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute;
}

const PrivatePractice360RouteRouteChildren: PrivatePractice360RouteRouteChildren =
  {
    PrivatePractice360BulkBundleCreateRoute:
      PrivatePractice360BulkBundleCreateRoute,
    PrivatePractice360BulkBundleLookupRoute:
      PrivatePractice360BulkBundleLookupRoute,
    PrivatePractice360BulkOrderCreateRoute:
      PrivatePractice360BulkOrderCreateRoute,
    PrivatePractice360BulkOrderLookupRoute:
      PrivatePractice360BulkOrderLookupRoute,
    PrivatePractice360BulkProductCreateRoute:
      PrivatePractice360BulkProductCreateRoute,
    PrivatePractice360BulkProductLookupRoute:
      PrivatePractice360BulkProductLookupRoute,
    PrivatePractice360BulkReorderLookupRoute:
      PrivatePractice360BulkReorderLookupRoute,
    PrivatePractice360BulkBundleBulkBundleIdEditRoute:
      PrivatePractice360BulkBundleBulkBundleIdEditRoute,
    PrivatePractice360BulkOrderBulkOrderIdEditRoute:
      PrivatePractice360BulkOrderBulkOrderIdEditRoute,
    PrivatePractice360BulkProductBulkProductIdEditRoute:
      PrivatePractice360BulkProductBulkProductIdEditRoute,
    PrivatePractice360BulkBundleBulkBundleIdIndexRoute:
      PrivatePractice360BulkBundleBulkBundleIdIndexRoute,
    PrivatePractice360BulkOrderBulkOrderIdIndexRoute:
      PrivatePractice360BulkOrderBulkOrderIdIndexRoute,
    PrivatePractice360BulkProductBulkProductIdIndexRoute:
      PrivatePractice360BulkProductBulkProductIdIndexRoute,
    PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute:
      PrivatePractice360BulkBundleBulkBundleIdProductsIndexRoute,
    PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute:
      PrivatePractice360BulkOrderBulkOrderIdContentsIndexRoute,
    PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute:
      PrivatePractice360BulkReorderBulkOrderIdScheduleIndexRoute,
  };

const PrivatePractice360RouteRouteWithChildren =
  PrivatePractice360RouteRoute._addFileChildren(
    PrivatePractice360RouteRouteChildren,
  );

interface PrivateSales360RouteRouteChildren {
  PrivateSales360CommissionsLookupRoute: typeof PrivateSales360CommissionsLookupRoute;
}

const PrivateSales360RouteRouteChildren: PrivateSales360RouteRouteChildren = {
  PrivateSales360CommissionsLookupRoute: PrivateSales360CommissionsLookupRoute,
};

const PrivateSales360RouteRouteWithChildren =
  PrivateSales360RouteRoute._addFileChildren(PrivateSales360RouteRouteChildren);

interface PrivateStock360RouteRouteChildren {
  PrivateStock360OwnedStockLookupRoute: typeof PrivateStock360OwnedStockLookupRoute;
  PrivateStock360StockOrderCreateRoute: typeof PrivateStock360StockOrderCreateRoute;
  PrivateStock360StockOrderLookupRoute: typeof PrivateStock360StockOrderLookupRoute;
  PrivateStock360StockOrderStockOrderIdEditRoute: typeof PrivateStock360StockOrderStockOrderIdEditRoute;
  PrivateStock360OwnedStockCatalogProductIdIndexRoute: typeof PrivateStock360OwnedStockCatalogProductIdIndexRoute;
  PrivateStock360StockOrderStockOrderIdIndexRoute: typeof PrivateStock360StockOrderStockOrderIdIndexRoute;
  PrivateStock360StockOrderStockOrderIdContentsIndexRoute: typeof PrivateStock360StockOrderStockOrderIdContentsIndexRoute;
}

const PrivateStock360RouteRouteChildren: PrivateStock360RouteRouteChildren = {
  PrivateStock360OwnedStockLookupRoute: PrivateStock360OwnedStockLookupRoute,
  PrivateStock360StockOrderCreateRoute: PrivateStock360StockOrderCreateRoute,
  PrivateStock360StockOrderLookupRoute: PrivateStock360StockOrderLookupRoute,
  PrivateStock360StockOrderStockOrderIdEditRoute:
    PrivateStock360StockOrderStockOrderIdEditRoute,
  PrivateStock360OwnedStockCatalogProductIdIndexRoute:
    PrivateStock360OwnedStockCatalogProductIdIndexRoute,
  PrivateStock360StockOrderStockOrderIdIndexRoute:
    PrivateStock360StockOrderStockOrderIdIndexRoute,
  PrivateStock360StockOrderStockOrderIdContentsIndexRoute:
    PrivateStock360StockOrderStockOrderIdContentsIndexRoute,
};

const PrivateStock360RouteRouteWithChildren =
  PrivateStock360RouteRoute._addFileChildren(PrivateStock360RouteRouteChildren);

interface PrivateWarehouse360AnalyticsRouteRouteChildren {
  PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute: typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute;
  PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute: typeof PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute;
}

const PrivateWarehouse360AnalyticsRouteRouteChildren: PrivateWarehouse360AnalyticsRouteRouteChildren =
  {
    PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute:
      PrivateWarehouse360AnalyticsWarehouse360AnalyticsIndexRoute,
    PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute:
      PrivateWarehouse360AnalyticsWarehouse360AnalyticsMonthlyHistoricIndexRoute,
  };

const PrivateWarehouse360AnalyticsRouteRouteWithChildren =
  PrivateWarehouse360AnalyticsRouteRoute._addFileChildren(
    PrivateWarehouse360AnalyticsRouteRouteChildren,
  );

interface PrivateWarehouse360RouteRouteChildren {
  PrivateWarehouse360AnalyticsRouteRoute: typeof PrivateWarehouse360AnalyticsRouteRouteWithChildren;
  PrivateWarehouse360PurchaseOrdersRoute: typeof PrivateWarehouse360PurchaseOrdersRoute;
  PrivateWarehouse360BatchCreateRoute: typeof PrivateWarehouse360BatchCreateRoute;
  PrivateWarehouse360BatchLookupRoute: typeof PrivateWarehouse360BatchLookupRoute;
  PrivateWarehouse360VendorCreateRoute: typeof PrivateWarehouse360VendorCreateRoute;
  PrivateWarehouse360VendorLookupRoute: typeof PrivateWarehouse360VendorLookupRoute;
  PrivateWarehouse360WarehouseVendorCreateRoute: typeof PrivateWarehouse360WarehouseVendorCreateRoute;
  PrivateWarehouse360WarehouseCreateRoute: typeof PrivateWarehouse360WarehouseCreateRoute;
  PrivateWarehouse360WarehouseLookupRoute: typeof PrivateWarehouse360WarehouseLookupRoute;
  PrivateWarehouse360BatchBatchIdEditRoute: typeof PrivateWarehouse360BatchBatchIdEditRoute;
  PrivateWarehouse360VendorVendorIdEditRoute: typeof PrivateWarehouse360VendorVendorIdEditRoute;
  PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute: typeof PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute;
  PrivateWarehouse360WarehouseWarehouseIdEditRoute: typeof PrivateWarehouse360WarehouseWarehouseIdEditRoute;
  PrivateWarehouse360BatchBatchIdIndexRoute: typeof PrivateWarehouse360BatchBatchIdIndexRoute;
  PrivateWarehouse360VendorVendorIdIndexRoute: typeof PrivateWarehouse360VendorVendorIdIndexRoute;
  PrivateWarehouse360WarehouseWarehouseIdIndexRoute: typeof PrivateWarehouse360WarehouseWarehouseIdIndexRoute;
}

const PrivateWarehouse360RouteRouteChildren: PrivateWarehouse360RouteRouteChildren =
  {
    PrivateWarehouse360AnalyticsRouteRoute:
      PrivateWarehouse360AnalyticsRouteRouteWithChildren,
    PrivateWarehouse360PurchaseOrdersRoute:
      PrivateWarehouse360PurchaseOrdersRoute,
    PrivateWarehouse360BatchCreateRoute: PrivateWarehouse360BatchCreateRoute,
    PrivateWarehouse360BatchLookupRoute: PrivateWarehouse360BatchLookupRoute,
    PrivateWarehouse360VendorCreateRoute: PrivateWarehouse360VendorCreateRoute,
    PrivateWarehouse360VendorLookupRoute: PrivateWarehouse360VendorLookupRoute,
    PrivateWarehouse360WarehouseVendorCreateRoute:
      PrivateWarehouse360WarehouseVendorCreateRoute,
    PrivateWarehouse360WarehouseCreateRoute:
      PrivateWarehouse360WarehouseCreateRoute,
    PrivateWarehouse360WarehouseLookupRoute:
      PrivateWarehouse360WarehouseLookupRoute,
    PrivateWarehouse360BatchBatchIdEditRoute:
      PrivateWarehouse360BatchBatchIdEditRoute,
    PrivateWarehouse360VendorVendorIdEditRoute:
      PrivateWarehouse360VendorVendorIdEditRoute,
    PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute:
      PrivateWarehouse360WarehouseVendorWarehouseVendorIdEditRoute,
    PrivateWarehouse360WarehouseWarehouseIdEditRoute:
      PrivateWarehouse360WarehouseWarehouseIdEditRoute,
    PrivateWarehouse360BatchBatchIdIndexRoute:
      PrivateWarehouse360BatchBatchIdIndexRoute,
    PrivateWarehouse360VendorVendorIdIndexRoute:
      PrivateWarehouse360VendorVendorIdIndexRoute,
    PrivateWarehouse360WarehouseWarehouseIdIndexRoute:
      PrivateWarehouse360WarehouseWarehouseIdIndexRoute,
  };

const PrivateWarehouse360RouteRouteWithChildren =
  PrivateWarehouse360RouteRoute._addFileChildren(
    PrivateWarehouse360RouteRouteChildren,
  );

interface PrivateCatalogProductRouteRouteChildren {
  PrivateCatalogProductCreateRoute: typeof PrivateCatalogProductCreateRoute;
  PrivateCatalogProductLookupRoute: typeof PrivateCatalogProductLookupRoute;
  PrivateCatalogProductCatalogProductIdEditRoute: typeof PrivateCatalogProductCatalogProductIdEditRoute;
  PrivateCatalogProductCatalogProductIdIndexRoute: typeof PrivateCatalogProductCatalogProductIdIndexRoute;
  PrivateCatalogProductCatalogProductIdComponentsIndexRoute: typeof PrivateCatalogProductCatalogProductIdComponentsIndexRoute;
}

const PrivateCatalogProductRouteRouteChildren: PrivateCatalogProductRouteRouteChildren =
  {
    PrivateCatalogProductCreateRoute: PrivateCatalogProductCreateRoute,
    PrivateCatalogProductLookupRoute: PrivateCatalogProductLookupRoute,
    PrivateCatalogProductCatalogProductIdEditRoute:
      PrivateCatalogProductCatalogProductIdEditRoute,
    PrivateCatalogProductCatalogProductIdIndexRoute:
      PrivateCatalogProductCatalogProductIdIndexRoute,
    PrivateCatalogProductCatalogProductIdComponentsIndexRoute:
      PrivateCatalogProductCatalogProductIdComponentsIndexRoute,
  };

const PrivateCatalogProductRouteRouteWithChildren =
  PrivateCatalogProductRouteRoute._addFileChildren(
    PrivateCatalogProductRouteRouteChildren,
  );

interface PrivateProductRouteRouteChildren {
  PrivateProductBasesRoute: typeof PrivateProductBasesRoute;
  PrivateProductBrandsRoute: typeof PrivateProductBrandsRoute;
  PrivateProductTreatmentsIndexRoute: typeof PrivateProductTreatmentsIndexRoute;
}

const PrivateProductRouteRouteChildren: PrivateProductRouteRouteChildren = {
  PrivateProductBasesRoute: PrivateProductBasesRoute,
  PrivateProductBrandsRoute: PrivateProductBrandsRoute,
  PrivateProductTreatmentsIndexRoute: PrivateProductTreatmentsIndexRoute,
};

const PrivateProductRouteRouteWithChildren =
  PrivateProductRouteRoute._addFileChildren(PrivateProductRouteRouteChildren);

interface PrivateRouteRouteChildren {
  PrivateAdminRouteRoute: typeof PrivateAdminRouteRouteWithChildren;
  PrivateBulkInvoiceRouteRoute: typeof PrivateBulkInvoiceRouteRouteWithChildren;
  PrivateFulfillment360RouteRoute: typeof PrivateFulfillment360RouteRouteWithChildren;
  PrivateInventory360RouteRoute: typeof PrivateInventory360RouteRouteWithChildren;
  PrivatePatient360RouteRoute: typeof PrivatePatient360RouteRouteWithChildren;
  PrivatePatientPharmcy360RouteRoute: typeof PrivatePatientPharmcy360RouteRouteWithChildren;
  PrivatePharmacy360RouteRoute: typeof PrivatePharmacy360RouteRouteWithChildren;
  PrivatePractice360RouteRoute: typeof PrivatePractice360RouteRouteWithChildren;
  PrivateSales360RouteRoute: typeof PrivateSales360RouteRouteWithChildren;
  PrivateStock360RouteRoute: typeof PrivateStock360RouteRouteWithChildren;
  PrivateWarehouse360RouteRoute: typeof PrivateWarehouse360RouteRouteWithChildren;
  PrivateCatalogProductRouteRoute: typeof PrivateCatalogProductRouteRouteWithChildren;
  PrivateProductRouteRoute: typeof PrivateProductRouteRouteWithChildren;
  PrivateReleaseNotesRoute: typeof PrivateReleaseNotesRoute;
  PrivateIndexRoute: typeof PrivateIndexRoute;
  PrivateTaskLookupRoute: typeof PrivateTaskLookupRoute;
  PrivateProfileIndexRoute: typeof PrivateProfileIndexRoute;
  PrivateEntityEntityIdIndexRoute: typeof PrivateEntityEntityIdIndexRoute;
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateAdminRouteRoute: PrivateAdminRouteRouteWithChildren,
  PrivateBulkInvoiceRouteRoute: PrivateBulkInvoiceRouteRouteWithChildren,
  PrivateFulfillment360RouteRoute: PrivateFulfillment360RouteRouteWithChildren,
  PrivateInventory360RouteRoute: PrivateInventory360RouteRouteWithChildren,
  PrivatePatient360RouteRoute: PrivatePatient360RouteRouteWithChildren,
  PrivatePatientPharmcy360RouteRoute:
    PrivatePatientPharmcy360RouteRouteWithChildren,
  PrivatePharmacy360RouteRoute: PrivatePharmacy360RouteRouteWithChildren,
  PrivatePractice360RouteRoute: PrivatePractice360RouteRouteWithChildren,
  PrivateSales360RouteRoute: PrivateSales360RouteRouteWithChildren,
  PrivateStock360RouteRoute: PrivateStock360RouteRouteWithChildren,
  PrivateWarehouse360RouteRoute: PrivateWarehouse360RouteRouteWithChildren,
  PrivateCatalogProductRouteRoute: PrivateCatalogProductRouteRouteWithChildren,
  PrivateProductRouteRoute: PrivateProductRouteRouteWithChildren,
  PrivateReleaseNotesRoute: PrivateReleaseNotesRoute,
  PrivateIndexRoute: PrivateIndexRoute,
  PrivateTaskLookupRoute: PrivateTaskLookupRoute,
  PrivateProfileIndexRoute: PrivateProfileIndexRoute,
  PrivateEntityEntityIdIndexRoute: PrivateEntityEntityIdIndexRoute,
};

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
);

interface PublicRouteRouteChildren {
  PublicMcpLoginRoute: typeof PublicMcpLoginRoute;
  PublicPrivacyPolicyRoute: typeof PublicPrivacyPolicyRoute;
  PublicTermsOfUseRoute: typeof PublicTermsOfUseRoute;
  PublicInstructionsPatientCampaignIdRoute: typeof PublicInstructionsPatientCampaignIdRoute;
  PublicPatientPaymentLinkPatientPaymentLinkIdRoute: typeof PublicPatientPaymentLinkPatientPaymentLinkIdRoute;
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicMcpLoginRoute: PublicMcpLoginRoute,
  PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,
  PublicTermsOfUseRoute: PublicTermsOfUseRoute,
  PublicInstructionsPatientCampaignIdRoute:
    PublicInstructionsPatientCampaignIdRoute,
  PublicPatientPaymentLinkPatientPaymentLinkIdRoute:
    PublicPatientPaymentLinkPatientPaymentLinkIdRoute,
};

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
);

interface AuthRouteRouteChildren {
  AuthActionRoute: typeof AuthActionRoute;
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute;
  AuthLoginRoute: typeof AuthLoginRoute;
  AuthMfaChallengeRoute: typeof AuthMfaChallengeRoute;
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthActionRoute: AuthActionRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMfaChallengeRoute: AuthMfaChallengeRoute,
};

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
